/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Api
 * FlashFarma API
 * OpenAPI spec version: 0.2.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminAuthResponse,
  AdminFfCardDraft,
  AdminFfCardDraftUpdate,
  AdminFfCardPage,
  AdminFfCardPublish,
  AdminFfCardVersion,
  AdminFfCardWorkspace,
  AdminLoginInput,
  AdminStats,
  AdminUser,
  Banca,
  BancaInput,
  BancaUpdate,
  BlocosInput,
  BlocosResponse,
  CompletableLearningModule,
  Concurso,
  ConcursoInput,
  ContentExportInput,
  ContentNotFoundResponse,
  ContentPdfResult,
  Conteudo,
  ConteudoInput,
  ConteudoUpdate,
  Coupon,
  CouponInput,
  CreateFfCardsSession,
  CreateSuggestionInput,
  CurrentStudentResponse,
  Disciplina,
  DisciplinaInput,
  DisciplinaUpdate,
  ErrorNotebookQuestionsInput,
  ErrorNotebookQuestionsResponse,
  ErrorNotebookResponse,
  ExportJob,
  FavoriteCount,
  FavoriteListResponse,
  FavoriteMutationResult,
  FavoriteState,
  FavoriteStatesInput,
  FavoriteStatesResponse,
  FfCardsErrorResponse,
  FfCardsHistory,
  FfCardsHome,
  FfCardsSession,
  FfCardsSessionResponse,
  FfCardsSessionSummary,
  FinanceiroDashboard,
  FlashcardFavoriteCount,
  FlashcardFavoriteListResponse,
  FlashcardFavoriteMutationResult,
  FlashcardFavoriteState,
  FlashcardFavoriteStatesInput,
  FlashcardFavoriteStatesResponse,
  FlashcardReveal,
  FlashcardReviewResult,
  GetErrorNotebookParams,
  GetQuestionPdf200,
  HealthStatus,
  HiddenFfCards,
  LearningBadRequestResponse,
  LearningContentIncompleteError,
  LearningContentProgress,
  LearningErrorResponse,
  LearningForbiddenResponse,
  LearningNotFoundResponse,
  LegacyQuestionEndpointGoneResponse,
  ListConteudosParams,
  ListFavoritesParams,
  ListFfCardsSessionsParams,
  ListFlashcardFavoritesParams,
  ListFlashcardsParams,
  ListMobileConteudosParams,
  ListMobileFlashcardsParams,
  ListMobileVideosParams,
  ListPublicQuestionsParams,
  ListQuestionNotebookQuestionsParams,
  ListQuestionNotebooksParams,
  ListQuestoesParams,
  ListRelatosParams,
  ListSimulationsParams,
  ListSolicitacoesParams,
  ListUnidadesParams,
  ListVideosParams,
  MobileBanca,
  MobileBlocosResponse,
  MobileConcurso,
  MobileConteudoList,
  MobileFlashcardListAllowedResponse,
  MobileVideoListAllowedResponse,
  NotebookExportInput,
  OfficialSimulationInput,
  Plan,
  PlanInput,
  PremiumRequiredResponse,
  Questao,
  QuestaoInput,
  QuestaoUpdate,
  QuestionAttemptFeedback,
  QuestionAttemptResult,
  QuestionDetails,
  QuestionListResponse,
  QuestionNotebook,
  QuestionNotebookInput,
  QuestionNotebookItemsResponse,
  QuestionNotebookListResponse,
  QuestionNotebookMutationResult,
  QuestionNotebookQuestionInput,
  QuestionNotebookStats,
  QuestionNotebookUpdate,
  QuestionsExportInput,
  ReactivateHiddenFfCard200,
  RefreshSessionResponse,
  RefreshTokenInput,
  Relato,
  RelatoInput,
  RelatoStatusInput,
  ReviewFfCard,
  SetSimulationRankingParticipationBody,
  Simulation,
  SimulationDetails,
  SimulationExportInput,
  SimulationInput,
  SimulationLeaderboard,
  SimulationList,
  SimulationResults,
  SimulationRun,
  Solicitacao,
  SolicitacaoStatusInput,
  StatisticsExportInput,
  StudentAuthResponse,
  StudentLoginInput,
  StudyProfile,
  StudyProfileInput,
  SubmitQuestionAttempt,
  Subscription,
  SubscriptionInput,
  SubscriptionWithRelations,
  Suggestion,
  UnauthorizedResponse,
  Unidade,
  UnidadeInput,
  UnidadeUpdate,
  UpdateConcursoConteudosBody,
  UpdateSimulationBody,
  UpdateUsuarioStatusBody,
  Usuario,
  ValidationErrorResponse,
  Video,
  VideoInput,
  VideoUpdate
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getStartContentFfCardsUrl = (contentId: string,) => {




  return `/api/mobile/ffcards/contents/${contentId}/start`
}

export const startContentFfCards = async (contentId: string, options?: RequestInit): Promise<FfCardsSession> => {

  return customFetch<FfCardsSession>(getStartContentFfCardsUrl(contentId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getStartContentFfCardsMutationOptions = <TError = ErrorType<UnauthorizedResponse | FfCardsErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startContentFfCards>>, TError,{contentId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof startContentFfCards>>, TError,{contentId: string}, TContext> => {

const mutationKey = ['startContentFfCards'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startContentFfCards>>, {contentId: string}> = (props) => {
          const {contentId} = props ?? {};

          return  startContentFfCards(contentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartContentFfCardsMutationResult = NonNullable<Awaited<ReturnType<typeof startContentFfCards>>>

    export type StartContentFfCardsMutationError = ErrorType<UnauthorizedResponse | FfCardsErrorResponse>

    export const useStartContentFfCards = <TError = ErrorType<UnauthorizedResponse | FfCardsErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startContentFfCards>>, TError,{contentId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof startContentFfCards>>,
        TError,
        {contentId: string},
        TContext
      > => {
      return useMutation(getStartContentFfCardsMutationOptions(options));
    }

export const getGetFfCardsHomeUrl = () => {




  return `/api/mobile/ffcards/home`
}

export const getFfCardsHome = async ( options?: RequestInit): Promise<FfCardsHome> => {

  return customFetch<FfCardsHome>(getGetFfCardsHomeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetFfCardsHomeQueryKey = () => {
    return [
    `/api/mobile/ffcards/home`
    ] as const;
    }


export const getGetFfCardsHomeQueryOptions = <TData = Awaited<ReturnType<typeof getFfCardsHome>>, TError = ErrorType<UnauthorizedResponse | FfCardsErrorResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFfCardsHome>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFfCardsHomeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFfCardsHome>>> = ({ signal }) => getFfCardsHome({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFfCardsHome>>, TError, TData> & { queryKey: QueryKey }
}

export type GetFfCardsHomeQueryResult = NonNullable<Awaited<ReturnType<typeof getFfCardsHome>>>
export type GetFfCardsHomeQueryError = ErrorType<UnauthorizedResponse | FfCardsErrorResponse>



export function useGetFfCardsHome<TData = Awaited<ReturnType<typeof getFfCardsHome>>, TError = ErrorType<UnauthorizedResponse | FfCardsErrorResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFfCardsHome>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetFfCardsHomeQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListFfCardsSessionsUrl = (params?: ListFfCardsSessionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/mobile/ffcards/sessions?${stringifiedParams}` : `/api/mobile/ffcards/sessions`
}

export const listFfCardsSessions = async (params?: ListFfCardsSessionsParams, options?: RequestInit): Promise<FfCardsHistory> => {

  return customFetch<FfCardsHistory>(getListFfCardsSessionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListFfCardsSessionsQueryKey = (params?: ListFfCardsSessionsParams,) => {
    return [
    `/api/mobile/ffcards/sessions`, ...(params ? [params] : [])
    ] as const;
    }


export const getListFfCardsSessionsQueryOptions = <TData = Awaited<ReturnType<typeof listFfCardsSessions>>, TError = ErrorType<FfCardsErrorResponse | UnauthorizedResponse>>(params?: ListFfCardsSessionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listFfCardsSessions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListFfCardsSessionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFfCardsSessions>>> = ({ signal }) => listFfCardsSessions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listFfCardsSessions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListFfCardsSessionsQueryResult = NonNullable<Awaited<ReturnType<typeof listFfCardsSessions>>>
export type ListFfCardsSessionsQueryError = ErrorType<FfCardsErrorResponse | UnauthorizedResponse>



export function useListFfCardsSessions<TData = Awaited<ReturnType<typeof listFfCardsSessions>>, TError = ErrorType<FfCardsErrorResponse | UnauthorizedResponse>>(
 params?: ListFfCardsSessionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listFfCardsSessions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListFfCardsSessionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateFfCardsSessionUrl = () => {




  return `/api/mobile/ffcards/sessions`
}

/**
 * Server-selects up to 50 authorized cards. Requires FFCARDS_ENABLED and FFCARDS_SESSIONS_ENABLED.
 */
export const createFfCardsSession = async (createFfCardsSession: CreateFfCardsSession, options?: RequestInit): Promise<FfCardsSession> => {

  return customFetch<FfCardsSession>(getCreateFfCardsSessionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createFfCardsSession,)
  }
);}




export const getCreateFfCardsSessionMutationOptions = <TError = ErrorType<FfCardsErrorResponse | UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFfCardsSession>>, TError,{data: BodyType<CreateFfCardsSession>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createFfCardsSession>>, TError,{data: BodyType<CreateFfCardsSession>}, TContext> => {

const mutationKey = ['createFfCardsSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFfCardsSession>>, {data: BodyType<CreateFfCardsSession>}> = (props) => {
          const {data} = props ?? {};

          return  createFfCardsSession(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFfCardsSessionMutationResult = NonNullable<Awaited<ReturnType<typeof createFfCardsSession>>>
    export type CreateFfCardsSessionMutationBody = BodyType<CreateFfCardsSession>
    export type CreateFfCardsSessionMutationError = ErrorType<FfCardsErrorResponse | UnauthorizedResponse>

    export const useCreateFfCardsSession = <TError = ErrorType<FfCardsErrorResponse | UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFfCardsSession>>, TError,{data: BodyType<CreateFfCardsSession>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createFfCardsSession>>,
        TError,
        {data: BodyType<CreateFfCardsSession>},
        TContext
      > => {
      return useMutation(getCreateFfCardsSessionMutationOptions(options));
    }

export const getGetActiveFfCardsSessionUrl = () => {




  return `/api/mobile/ffcards/sessions/active`
}

export const getActiveFfCardsSession = async ( options?: RequestInit): Promise<FfCardsSession | null> => {

  return customFetch<FfCardsSession | null>(getGetActiveFfCardsSessionUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetActiveFfCardsSessionQueryKey = () => {
    return [
    `/api/mobile/ffcards/sessions/active`
    ] as const;
    }


export const getGetActiveFfCardsSessionQueryOptions = <TData = Awaited<ReturnType<typeof getActiveFfCardsSession>>, TError = ErrorType<UnauthorizedResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getActiveFfCardsSession>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActiveFfCardsSessionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActiveFfCardsSession>>> = ({ signal }) => getActiveFfCardsSession({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActiveFfCardsSession>>, TError, TData> & { queryKey: QueryKey }
}

export type GetActiveFfCardsSessionQueryResult = NonNullable<Awaited<ReturnType<typeof getActiveFfCardsSession>>>
export type GetActiveFfCardsSessionQueryError = ErrorType<UnauthorizedResponse>



export function useGetActiveFfCardsSession<TData = Awaited<ReturnType<typeof getActiveFfCardsSession>>, TError = ErrorType<UnauthorizedResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getActiveFfCardsSession>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetActiveFfCardsSessionQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetFfCardsSessionUrl = (sessionId: string,) => {




  return `/api/mobile/ffcards/sessions/${sessionId}`
}

export const getFfCardsSession = async (sessionId: string, options?: RequestInit): Promise<FfCardsSession> => {

  return customFetch<FfCardsSession>(getGetFfCardsSessionUrl(sessionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetFfCardsSessionQueryKey = (sessionId: string,) => {
    return [
    `/api/mobile/ffcards/sessions/${sessionId}`
    ] as const;
    }


export const getGetFfCardsSessionQueryOptions = <TData = Awaited<ReturnType<typeof getFfCardsSession>>, TError = ErrorType<UnauthorizedResponse | FfCardsErrorResponse>>(sessionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFfCardsSession>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFfCardsSessionQueryKey(sessionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFfCardsSession>>> = ({ signal }) => getFfCardsSession(sessionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(sessionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFfCardsSession>>, TError, TData> & { queryKey: QueryKey }
}

export type GetFfCardsSessionQueryResult = NonNullable<Awaited<ReturnType<typeof getFfCardsSession>>>
export type GetFfCardsSessionQueryError = ErrorType<UnauthorizedResponse | FfCardsErrorResponse>



export function useGetFfCardsSession<TData = Awaited<ReturnType<typeof getFfCardsSession>>, TError = ErrorType<UnauthorizedResponse | FfCardsErrorResponse>>(
 sessionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFfCardsSession>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetFfCardsSessionQueryOptions(sessionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getRevealFfCardUrl = (sessionId: string,
    itemId: string,) => {




  return `/api/mobile/ffcards/sessions/${sessionId}/items/${itemId}/reveal`
}

/**
 * Idempotently reveals only the currently authorized item and pins its published editorial version.
 */
export const revealFfCard = async (sessionId: string,
    itemId: string, options?: RequestInit): Promise<FlashcardReveal> => {

  return customFetch<FlashcardReveal>(getRevealFfCardUrl(sessionId,itemId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRevealFfCardMutationOptions = <TError = ErrorType<UnauthorizedResponse | FfCardsErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revealFfCard>>, TError,{sessionId: string;itemId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof revealFfCard>>, TError,{sessionId: string;itemId: string}, TContext> => {

const mutationKey = ['revealFfCard'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revealFfCard>>, {sessionId: string;itemId: string}> = (props) => {
          const {sessionId,itemId} = props ?? {};

          return  revealFfCard(sessionId,itemId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevealFfCardMutationResult = NonNullable<Awaited<ReturnType<typeof revealFfCard>>>

    export type RevealFfCardMutationError = ErrorType<UnauthorizedResponse | FfCardsErrorResponse>

    export const useRevealFfCard = <TError = ErrorType<UnauthorizedResponse | FfCardsErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revealFfCard>>, TError,{sessionId: string;itemId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof revealFfCard>>,
        TError,
        {sessionId: string;itemId: string},
        TContext
      > => {
      return useMutation(getRevealFfCardMutationOptions(options));
    }

export const getReviewFfCardUrl = (sessionId: string,
    itemId: string,) => {




  return `/api/mobile/ffcards/sessions/${sessionId}/items/${itemId}/reviews`
}

/**
 * Idempotency is scoped by authenticated user and requestId; divergent retries return 409. Free practice never changes the official schedule.
 */
export const reviewFfCard = async (sessionId: string,
    itemId: string,
    reviewFfCard: ReviewFfCard, options?: RequestInit): Promise<FlashcardReviewResult> => {

  return customFetch<FlashcardReviewResult>(getReviewFfCardUrl(sessionId,itemId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      reviewFfCard,)
  }
);}




export const getReviewFfCardMutationOptions = <TError = ErrorType<FfCardsErrorResponse | UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewFfCard>>, TError,{sessionId: string;itemId: string;data: BodyType<ReviewFfCard>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reviewFfCard>>, TError,{sessionId: string;itemId: string;data: BodyType<ReviewFfCard>}, TContext> => {

const mutationKey = ['reviewFfCard'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reviewFfCard>>, {sessionId: string;itemId: string;data: BodyType<ReviewFfCard>}> = (props) => {
          const {sessionId,itemId,data} = props ?? {};

          return  reviewFfCard(sessionId,itemId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReviewFfCardMutationResult = NonNullable<Awaited<ReturnType<typeof reviewFfCard>>>
    export type ReviewFfCardMutationBody = BodyType<ReviewFfCard>
    export type ReviewFfCardMutationError = ErrorType<FfCardsErrorResponse | UnauthorizedResponse>

    export const useReviewFfCard = <TError = ErrorType<FfCardsErrorResponse | UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewFfCard>>, TError,{sessionId: string;itemId: string;data: BodyType<ReviewFfCard>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reviewFfCard>>,
        TError,
        {sessionId: string;itemId: string;data: BodyType<ReviewFfCard>},
        TContext
      > => {
      return useMutation(getReviewFfCardMutationOptions(options));
    }

export const getHideCurrentFfCardUrl = (sessionId: string,
    itemId: string,) => {




  return `/api/mobile/ffcards/sessions/${sessionId}/items/${itemId}/hide`
}

/**
 * Voluntarily hides a mature card from the official schedule and advances the current session.
 */
export const hideCurrentFfCard = async (sessionId: string,
    itemId: string, options?: RequestInit): Promise<FfCardsSession> => {

  return customFetch<FfCardsSession>(getHideCurrentFfCardUrl(sessionId,itemId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getHideCurrentFfCardMutationOptions = <TError = ErrorType<FfCardsErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hideCurrentFfCard>>, TError,{sessionId: string;itemId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hideCurrentFfCard>>, TError,{sessionId: string;itemId: string}, TContext> => {

const mutationKey = ['hideCurrentFfCard'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hideCurrentFfCard>>, {sessionId: string;itemId: string}> = (props) => {
          const {sessionId,itemId} = props ?? {};

          return  hideCurrentFfCard(sessionId,itemId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HideCurrentFfCardMutationResult = NonNullable<Awaited<ReturnType<typeof hideCurrentFfCard>>>

    export type HideCurrentFfCardMutationError = ErrorType<FfCardsErrorResponse>

    export const useHideCurrentFfCard = <TError = ErrorType<FfCardsErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hideCurrentFfCard>>, TError,{sessionId: string;itemId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof hideCurrentFfCard>>,
        TError,
        {sessionId: string;itemId: string},
        TContext
      > => {
      return useMutation(getHideCurrentFfCardMutationOptions(options));
    }

export const getPauseFfCardsSessionUrl = (sessionId: string,) => {




  return `/api/mobile/ffcards/sessions/${sessionId}/pause`
}

export const pauseFfCardsSession = async (sessionId: string, options?: RequestInit): Promise<FfCardsSessionResponse> => {

  return customFetch<FfCardsSessionResponse>(getPauseFfCardsSessionUrl(sessionId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPauseFfCardsSessionMutationOptions = <TError = ErrorType<FfCardsErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pauseFfCardsSession>>, TError,{sessionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof pauseFfCardsSession>>, TError,{sessionId: string}, TContext> => {

const mutationKey = ['pauseFfCardsSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pauseFfCardsSession>>, {sessionId: string}> = (props) => {
          const {sessionId} = props ?? {};

          return  pauseFfCardsSession(sessionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PauseFfCardsSessionMutationResult = NonNullable<Awaited<ReturnType<typeof pauseFfCardsSession>>>

    export type PauseFfCardsSessionMutationError = ErrorType<FfCardsErrorResponse>

    export const usePauseFfCardsSession = <TError = ErrorType<FfCardsErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pauseFfCardsSession>>, TError,{sessionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof pauseFfCardsSession>>,
        TError,
        {sessionId: string},
        TContext
      > => {
      return useMutation(getPauseFfCardsSessionMutationOptions(options));
    }

export const getResumeFfCardsSessionUrl = (sessionId: string,) => {




  return `/api/mobile/ffcards/sessions/${sessionId}/resume`
}

export const resumeFfCardsSession = async (sessionId: string, options?: RequestInit): Promise<FfCardsSessionResponse> => {

  return customFetch<FfCardsSessionResponse>(getResumeFfCardsSessionUrl(sessionId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getResumeFfCardsSessionMutationOptions = <TError = ErrorType<FfCardsErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resumeFfCardsSession>>, TError,{sessionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resumeFfCardsSession>>, TError,{sessionId: string}, TContext> => {

const mutationKey = ['resumeFfCardsSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resumeFfCardsSession>>, {sessionId: string}> = (props) => {
          const {sessionId} = props ?? {};

          return  resumeFfCardsSession(sessionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResumeFfCardsSessionMutationResult = NonNullable<Awaited<ReturnType<typeof resumeFfCardsSession>>>

    export type ResumeFfCardsSessionMutationError = ErrorType<FfCardsErrorResponse>

    export const useResumeFfCardsSession = <TError = ErrorType<FfCardsErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resumeFfCardsSession>>, TError,{sessionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof resumeFfCardsSession>>,
        TError,
        {sessionId: string},
        TContext
      > => {
      return useMutation(getResumeFfCardsSessionMutationOptions(options));
    }

export const getCompleteFfCardsSessionUrl = (sessionId: string,) => {




  return `/api/mobile/ffcards/sessions/${sessionId}/complete`
}

export const completeFfCardsSession = async (sessionId: string, options?: RequestInit): Promise<FfCardsSessionResponse> => {

  return customFetch<FfCardsSessionResponse>(getCompleteFfCardsSessionUrl(sessionId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getCompleteFfCardsSessionMutationOptions = <TError = ErrorType<FfCardsErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeFfCardsSession>>, TError,{sessionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof completeFfCardsSession>>, TError,{sessionId: string}, TContext> => {

const mutationKey = ['completeFfCardsSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeFfCardsSession>>, {sessionId: string}> = (props) => {
          const {sessionId} = props ?? {};

          return  completeFfCardsSession(sessionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteFfCardsSessionMutationResult = NonNullable<Awaited<ReturnType<typeof completeFfCardsSession>>>

    export type CompleteFfCardsSessionMutationError = ErrorType<FfCardsErrorResponse>

    export const useCompleteFfCardsSession = <TError = ErrorType<FfCardsErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeFfCardsSession>>, TError,{sessionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof completeFfCardsSession>>,
        TError,
        {sessionId: string},
        TContext
      > => {
      return useMutation(getCompleteFfCardsSessionMutationOptions(options));
    }

export const getAbandonFfCardsSessionUrl = (sessionId: string,) => {




  return `/api/mobile/ffcards/sessions/${sessionId}/abandon`
}

export const abandonFfCardsSession = async (sessionId: string, options?: RequestInit): Promise<FfCardsSessionResponse> => {

  return customFetch<FfCardsSessionResponse>(getAbandonFfCardsSessionUrl(sessionId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getAbandonFfCardsSessionMutationOptions = <TError = ErrorType<FfCardsErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof abandonFfCardsSession>>, TError,{sessionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof abandonFfCardsSession>>, TError,{sessionId: string}, TContext> => {

const mutationKey = ['abandonFfCardsSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof abandonFfCardsSession>>, {sessionId: string}> = (props) => {
          const {sessionId} = props ?? {};

          return  abandonFfCardsSession(sessionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AbandonFfCardsSessionMutationResult = NonNullable<Awaited<ReturnType<typeof abandonFfCardsSession>>>

    export type AbandonFfCardsSessionMutationError = ErrorType<FfCardsErrorResponse>

    export const useAbandonFfCardsSession = <TError = ErrorType<FfCardsErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof abandonFfCardsSession>>, TError,{sessionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof abandonFfCardsSession>>,
        TError,
        {sessionId: string},
        TContext
      > => {
      return useMutation(getAbandonFfCardsSessionMutationOptions(options));
    }

export const getGetFfCardsSessionSummaryUrl = (sessionId: string,) => {




  return `/api/mobile/ffcards/sessions/${sessionId}/summary`
}

export const getFfCardsSessionSummary = async (sessionId: string, options?: RequestInit): Promise<FfCardsSessionSummary> => {

  return customFetch<FfCardsSessionSummary>(getGetFfCardsSessionSummaryUrl(sessionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetFfCardsSessionSummaryQueryKey = (sessionId: string,) => {
    return [
    `/api/mobile/ffcards/sessions/${sessionId}/summary`
    ] as const;
    }


export const getGetFfCardsSessionSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getFfCardsSessionSummary>>, TError = ErrorType<FfCardsErrorResponse>>(sessionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFfCardsSessionSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFfCardsSessionSummaryQueryKey(sessionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFfCardsSessionSummary>>> = ({ signal }) => getFfCardsSessionSummary(sessionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(sessionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFfCardsSessionSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetFfCardsSessionSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getFfCardsSessionSummary>>>
export type GetFfCardsSessionSummaryQueryError = ErrorType<FfCardsErrorResponse>



export function useGetFfCardsSessionSummary<TData = Awaited<ReturnType<typeof getFfCardsSessionSummary>>, TError = ErrorType<FfCardsErrorResponse>>(
 sessionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFfCardsSessionSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetFfCardsSessionSummaryQueryOptions(sessionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListHiddenFfCardsUrl = () => {




  return `/api/mobile/ffcards/hidden`
}

export const listHiddenFfCards = async ( options?: RequestInit): Promise<HiddenFfCards> => {

  return customFetch<HiddenFfCards>(getListHiddenFfCardsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListHiddenFfCardsQueryKey = () => {
    return [
    `/api/mobile/ffcards/hidden`
    ] as const;
    }


export const getListHiddenFfCardsQueryOptions = <TData = Awaited<ReturnType<typeof listHiddenFfCards>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHiddenFfCards>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListHiddenFfCardsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listHiddenFfCards>>> = ({ signal }) => listHiddenFfCards({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listHiddenFfCards>>, TError, TData> & { queryKey: QueryKey }
}

export type ListHiddenFfCardsQueryResult = NonNullable<Awaited<ReturnType<typeof listHiddenFfCards>>>
export type ListHiddenFfCardsQueryError = ErrorType<unknown>



export function useListHiddenFfCards<TData = Awaited<ReturnType<typeof listHiddenFfCards>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHiddenFfCards>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListHiddenFfCardsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getReactivateHiddenFfCardUrl = (flashcardId: number,) => {




  return `/api/mobile/ffcards/hidden/${flashcardId}/reactivate`
}

export const reactivateHiddenFfCard = async (flashcardId: number, options?: RequestInit): Promise<ReactivateHiddenFfCard200> => {

  return customFetch<ReactivateHiddenFfCard200>(getReactivateHiddenFfCardUrl(flashcardId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getReactivateHiddenFfCardMutationOptions = <TError = ErrorType<FfCardsErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reactivateHiddenFfCard>>, TError,{flashcardId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reactivateHiddenFfCard>>, TError,{flashcardId: number}, TContext> => {

const mutationKey = ['reactivateHiddenFfCard'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reactivateHiddenFfCard>>, {flashcardId: number}> = (props) => {
          const {flashcardId} = props ?? {};

          return  reactivateHiddenFfCard(flashcardId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReactivateHiddenFfCardMutationResult = NonNullable<Awaited<ReturnType<typeof reactivateHiddenFfCard>>>

    export type ReactivateHiddenFfCardMutationError = ErrorType<FfCardsErrorResponse>

    export const useReactivateHiddenFfCard = <TError = ErrorType<FfCardsErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reactivateHiddenFfCard>>, TError,{flashcardId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reactivateHiddenFfCard>>,
        TError,
        {flashcardId: number},
        TContext
      > => {
      return useMutation(getReactivateHiddenFfCardMutationOptions(options));
    }

export const getListFlashcardFavoritesUrl = (params?: ListFlashcardFavoritesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/mobile/ffcards/favorites?${stringifiedParams}` : `/api/mobile/ffcards/favorites`
}

export const listFlashcardFavorites = async (params?: ListFlashcardFavoritesParams, options?: RequestInit): Promise<FlashcardFavoriteListResponse> => {

  return customFetch<FlashcardFavoriteListResponse>(getListFlashcardFavoritesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListFlashcardFavoritesQueryKey = (params?: ListFlashcardFavoritesParams,) => {
    return [
    `/api/mobile/ffcards/favorites`, ...(params ? [params] : [])
    ] as const;
    }


export const getListFlashcardFavoritesQueryOptions = <TData = Awaited<ReturnType<typeof listFlashcardFavorites>>, TError = ErrorType<FfCardsErrorResponse | UnauthorizedResponse>>(params?: ListFlashcardFavoritesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listFlashcardFavorites>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListFlashcardFavoritesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFlashcardFavorites>>> = ({ signal }) => listFlashcardFavorites(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listFlashcardFavorites>>, TError, TData> & { queryKey: QueryKey }
}

export type ListFlashcardFavoritesQueryResult = NonNullable<Awaited<ReturnType<typeof listFlashcardFavorites>>>
export type ListFlashcardFavoritesQueryError = ErrorType<FfCardsErrorResponse | UnauthorizedResponse>



export function useListFlashcardFavorites<TData = Awaited<ReturnType<typeof listFlashcardFavorites>>, TError = ErrorType<FfCardsErrorResponse | UnauthorizedResponse>>(
 params?: ListFlashcardFavoritesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listFlashcardFavorites>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListFlashcardFavoritesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCountFlashcardFavoritesUrl = () => {




  return `/api/mobile/ffcards/favorites/count`
}

export const countFlashcardFavorites = async ( options?: RequestInit): Promise<FlashcardFavoriteCount> => {

  return customFetch<FlashcardFavoriteCount>(getCountFlashcardFavoritesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCountFlashcardFavoritesQueryKey = () => {
    return [
    `/api/mobile/ffcards/favorites/count`
    ] as const;
    }


export const getCountFlashcardFavoritesQueryOptions = <TData = Awaited<ReturnType<typeof countFlashcardFavorites>>, TError = ErrorType<UnauthorizedResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof countFlashcardFavorites>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCountFlashcardFavoritesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof countFlashcardFavorites>>> = ({ signal }) => countFlashcardFavorites({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof countFlashcardFavorites>>, TError, TData> & { queryKey: QueryKey }
}

export type CountFlashcardFavoritesQueryResult = NonNullable<Awaited<ReturnType<typeof countFlashcardFavorites>>>
export type CountFlashcardFavoritesQueryError = ErrorType<UnauthorizedResponse>



export function useCountFlashcardFavorites<TData = Awaited<ReturnType<typeof countFlashcardFavorites>>, TError = ErrorType<UnauthorizedResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof countFlashcardFavorites>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getCountFlashcardFavoritesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetFlashcardFavoriteStatesUrl = () => {




  return `/api/mobile/ffcards/favorite-states`
}

export const getFlashcardFavoriteStates = async (flashcardFavoriteStatesInput: FlashcardFavoriteStatesInput, options?: RequestInit): Promise<FlashcardFavoriteStatesResponse> => {

  return customFetch<FlashcardFavoriteStatesResponse>(getGetFlashcardFavoriteStatesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      flashcardFavoriteStatesInput,)
  }
);}




export const getGetFlashcardFavoriteStatesMutationOptions = <TError = ErrorType<FfCardsErrorResponse | UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getFlashcardFavoriteStates>>, TError,{data: BodyType<FlashcardFavoriteStatesInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof getFlashcardFavoriteStates>>, TError,{data: BodyType<FlashcardFavoriteStatesInput>}, TContext> => {

const mutationKey = ['getFlashcardFavoriteStates'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getFlashcardFavoriteStates>>, {data: BodyType<FlashcardFavoriteStatesInput>}> = (props) => {
          const {data} = props ?? {};

          return  getFlashcardFavoriteStates(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetFlashcardFavoriteStatesMutationResult = NonNullable<Awaited<ReturnType<typeof getFlashcardFavoriteStates>>>
    export type GetFlashcardFavoriteStatesMutationBody = BodyType<FlashcardFavoriteStatesInput>
    export type GetFlashcardFavoriteStatesMutationError = ErrorType<FfCardsErrorResponse | UnauthorizedResponse>

    export const useGetFlashcardFavoriteStates = <TError = ErrorType<FfCardsErrorResponse | UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getFlashcardFavoriteStates>>, TError,{data: BodyType<FlashcardFavoriteStatesInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof getFlashcardFavoriteStates>>,
        TError,
        {data: BodyType<FlashcardFavoriteStatesInput>},
        TContext
      > => {
      return useMutation(getGetFlashcardFavoriteStatesMutationOptions(options));
    }

export const getGetFlashcardFavoriteStateUrl = (flashcardId: number,) => {




  return `/api/mobile/ffcards/${flashcardId}/favorite`
}

export const getFlashcardFavoriteState = async (flashcardId: number, options?: RequestInit): Promise<FlashcardFavoriteState> => {

  return customFetch<FlashcardFavoriteState>(getGetFlashcardFavoriteStateUrl(flashcardId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetFlashcardFavoriteStateQueryKey = (flashcardId: number,) => {
    return [
    `/api/mobile/ffcards/${flashcardId}/favorite`
    ] as const;
    }


export const getGetFlashcardFavoriteStateQueryOptions = <TData = Awaited<ReturnType<typeof getFlashcardFavoriteState>>, TError = ErrorType<FfCardsErrorResponse>>(flashcardId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFlashcardFavoriteState>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFlashcardFavoriteStateQueryKey(flashcardId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFlashcardFavoriteState>>> = ({ signal }) => getFlashcardFavoriteState(flashcardId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(flashcardId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFlashcardFavoriteState>>, TError, TData> & { queryKey: QueryKey }
}

export type GetFlashcardFavoriteStateQueryResult = NonNullable<Awaited<ReturnType<typeof getFlashcardFavoriteState>>>
export type GetFlashcardFavoriteStateQueryError = ErrorType<FfCardsErrorResponse>



export function useGetFlashcardFavoriteState<TData = Awaited<ReturnType<typeof getFlashcardFavoriteState>>, TError = ErrorType<FfCardsErrorResponse>>(
 flashcardId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFlashcardFavoriteState>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetFlashcardFavoriteStateQueryOptions(flashcardId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getAddFlashcardFavoriteUrl = (flashcardId: number,) => {




  return `/api/mobile/ffcards/${flashcardId}/favorite`
}

export const addFlashcardFavorite = async (flashcardId: number, options?: RequestInit): Promise<FlashcardFavoriteMutationResult> => {

  return customFetch<FlashcardFavoriteMutationResult>(getAddFlashcardFavoriteUrl(flashcardId),
  {
    ...options,
    method: 'PUT'


  }
);}




export const getAddFlashcardFavoriteMutationOptions = <TError = ErrorType<FfCardsErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addFlashcardFavorite>>, TError,{flashcardId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addFlashcardFavorite>>, TError,{flashcardId: number}, TContext> => {

const mutationKey = ['addFlashcardFavorite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addFlashcardFavorite>>, {flashcardId: number}> = (props) => {
          const {flashcardId} = props ?? {};

          return  addFlashcardFavorite(flashcardId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddFlashcardFavoriteMutationResult = NonNullable<Awaited<ReturnType<typeof addFlashcardFavorite>>>

    export type AddFlashcardFavoriteMutationError = ErrorType<FfCardsErrorResponse>

    export const useAddFlashcardFavorite = <TError = ErrorType<FfCardsErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addFlashcardFavorite>>, TError,{flashcardId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addFlashcardFavorite>>,
        TError,
        {flashcardId: number},
        TContext
      > => {
      return useMutation(getAddFlashcardFavoriteMutationOptions(options));
    }

export const getRemoveFlashcardFavoriteUrl = (flashcardId: number,) => {




  return `/api/mobile/ffcards/${flashcardId}/favorite`
}

export const removeFlashcardFavorite = async (flashcardId: number, options?: RequestInit): Promise<FlashcardFavoriteMutationResult> => {

  return customFetch<FlashcardFavoriteMutationResult>(getRemoveFlashcardFavoriteUrl(flashcardId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getRemoveFlashcardFavoriteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeFlashcardFavorite>>, TError,{flashcardId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeFlashcardFavorite>>, TError,{flashcardId: number}, TContext> => {

const mutationKey = ['removeFlashcardFavorite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeFlashcardFavorite>>, {flashcardId: number}> = (props) => {
          const {flashcardId} = props ?? {};

          return  removeFlashcardFavorite(flashcardId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveFlashcardFavoriteMutationResult = NonNullable<Awaited<ReturnType<typeof removeFlashcardFavorite>>>

    export type RemoveFlashcardFavoriteMutationError = ErrorType<unknown>

    export const useRemoveFlashcardFavorite = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeFlashcardFavorite>>, TError,{flashcardId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof removeFlashcardFavorite>>,
        TError,
        {flashcardId: number},
        TContext
      > => {
      return useMutation(getRemoveFlashcardFavoriteMutationOptions(options));
    }

export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * @summary Health check
 */
export const healthCheck = async ( options?: RequestInit): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getStudentLoginUrl = () => {




  return `/api/auth/login`
}

/**
 * @summary Authenticate a student
 */
export const studentLogin = async (studentLoginInput: StudentLoginInput, options?: RequestInit): Promise<StudentAuthResponse> => {

  return customFetch<StudentAuthResponse>(getStudentLoginUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      studentLoginInput,)
  }
);}




export const getStudentLoginMutationOptions = <TError = ErrorType<ValidationErrorResponse | UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof studentLogin>>, TError,{data: BodyType<StudentLoginInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof studentLogin>>, TError,{data: BodyType<StudentLoginInput>}, TContext> => {

const mutationKey = ['studentLogin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof studentLogin>>, {data: BodyType<StudentLoginInput>}> = (props) => {
          const {data} = props ?? {};

          return  studentLogin(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StudentLoginMutationResult = NonNullable<Awaited<ReturnType<typeof studentLogin>>>
    export type StudentLoginMutationBody = BodyType<StudentLoginInput>
    export type StudentLoginMutationError = ErrorType<ValidationErrorResponse | UnauthorizedResponse>

    /**
 * @summary Authenticate a student
 */
export const useStudentLogin = <TError = ErrorType<ValidationErrorResponse | UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof studentLogin>>, TError,{data: BodyType<StudentLoginInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof studentLogin>>,
        TError,
        {data: BodyType<StudentLoginInput>},
        TContext
      > => {
      return useMutation(getStudentLoginMutationOptions(options));
    }

export const getRefreshStudentSessionUrl = () => {




  return `/api/auth/refresh`
}

/**
 * @summary Rotate a student refresh token
 */
export const refreshStudentSession = async (refreshTokenInput: RefreshTokenInput, options?: RequestInit): Promise<RefreshSessionResponse> => {

  return customFetch<RefreshSessionResponse>(getRefreshStudentSessionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      refreshTokenInput,)
  }
);}




export const getRefreshStudentSessionMutationOptions = <TError = ErrorType<ValidationErrorResponse | UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshStudentSession>>, TError,{data: BodyType<RefreshTokenInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof refreshStudentSession>>, TError,{data: BodyType<RefreshTokenInput>}, TContext> => {

const mutationKey = ['refreshStudentSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshStudentSession>>, {data: BodyType<RefreshTokenInput>}> = (props) => {
          const {data} = props ?? {};

          return  refreshStudentSession(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefreshStudentSessionMutationResult = NonNullable<Awaited<ReturnType<typeof refreshStudentSession>>>
    export type RefreshStudentSessionMutationBody = BodyType<RefreshTokenInput>
    export type RefreshStudentSessionMutationError = ErrorType<ValidationErrorResponse | UnauthorizedResponse>

    /**
 * @summary Rotate a student refresh token
 */
export const useRefreshStudentSession = <TError = ErrorType<ValidationErrorResponse | UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshStudentSession>>, TError,{data: BodyType<RefreshTokenInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof refreshStudentSession>>,
        TError,
        {data: BodyType<RefreshTokenInput>},
        TContext
      > => {
      return useMutation(getRefreshStudentSessionMutationOptions(options));
    }

export const getLogoutStudentUrl = () => {




  return `/api/auth/logout`
}

/**
 * @summary Invalidate a student refresh token
 */
export const logoutStudent = async (refreshTokenInput: RefreshTokenInput, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getLogoutStudentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      refreshTokenInput,)
  }
);}




export const getLogoutStudentMutationOptions = <TError = ErrorType<ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutStudent>>, TError,{data: BodyType<RefreshTokenInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof logoutStudent>>, TError,{data: BodyType<RefreshTokenInput>}, TContext> => {

const mutationKey = ['logoutStudent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logoutStudent>>, {data: BodyType<RefreshTokenInput>}> = (props) => {
          const {data} = props ?? {};

          return  logoutStudent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LogoutStudentMutationResult = NonNullable<Awaited<ReturnType<typeof logoutStudent>>>
    export type LogoutStudentMutationBody = BodyType<RefreshTokenInput>
    export type LogoutStudentMutationError = ErrorType<ValidationErrorResponse>

    /**
 * @summary Invalidate a student refresh token
 */
export const useLogoutStudent = <TError = ErrorType<ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutStudent>>, TError,{data: BodyType<RefreshTokenInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof logoutStudent>>,
        TError,
        {data: BodyType<RefreshTokenInput>},
        TContext
      > => {
      return useMutation(getLogoutStudentMutationOptions(options));
    }

export const getGetCurrentStudentUrl = () => {




  return `/api/auth/me`
}

/**
 * @summary Get the authenticated student identity
 */
export const getCurrentStudent = async ( options?: RequestInit): Promise<CurrentStudentResponse> => {

  return customFetch<CurrentStudentResponse>(getGetCurrentStudentUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCurrentStudentQueryKey = () => {
    return [
    `/api/auth/me`
    ] as const;
    }


export const getGetCurrentStudentQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentStudent>>, TError = ErrorType<UnauthorizedResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCurrentStudent>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentStudentQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentStudent>>> = ({ signal }) => getCurrentStudent({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentStudent>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCurrentStudentQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentStudent>>>
export type GetCurrentStudentQueryError = ErrorType<UnauthorizedResponse>


/**
 * @summary Get the authenticated student identity
 */

export function useGetCurrentStudent<TData = Awaited<ReturnType<typeof getCurrentStudent>>, TError = ErrorType<UnauthorizedResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCurrentStudent>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCurrentStudentQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListMobileConteudosUrl = (params?: ListMobileConteudosParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/mobile/conteudos?${stringifiedParams}` : `/api/mobile/conteudos`
}

/**
 * All active contents remain visible. hasAccess is informational; internal materials are never embedded in this response.
 * @summary List visible content metadata
 */
export const listMobileConteudos = async (params?: ListMobileConteudosParams, options?: RequestInit): Promise<MobileConteudoList> => {

  return customFetch<MobileConteudoList>(getListMobileConteudosUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMobileConteudosQueryKey = (params?: ListMobileConteudosParams,) => {
    return [
    `/api/mobile/conteudos`, ...(params ? [params] : [])
    ] as const;
    }


export const getListMobileConteudosQueryOptions = <TData = Awaited<ReturnType<typeof listMobileConteudos>>, TError = ErrorType<UnauthorizedResponse>>(params?: ListMobileConteudosParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMobileConteudos>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMobileConteudosQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMobileConteudos>>> = ({ signal }) => listMobileConteudos(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMobileConteudos>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMobileConteudosQueryResult = NonNullable<Awaited<ReturnType<typeof listMobileConteudos>>>
export type ListMobileConteudosQueryError = ErrorType<UnauthorizedResponse>


/**
 * @summary List visible content metadata
 */

export function useListMobileConteudos<TData = Awaited<ReturnType<typeof listMobileConteudos>>, TError = ErrorType<UnauthorizedResponse>>(
 params?: ListMobileConteudosParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMobileConteudos>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMobileConteudosQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getStartContentProgressUrl = (id: string,) => {




  return `/api/mobile/learning/contents/${id}/progress`
}

/**
 * Returns the same official backend progress on repeated calls and across devices. Available only while learning_progress_enabled is active.
 * @summary Read or idempotently start the authenticated student's content progress
 */
export const startContentProgress = async (id: string, options?: RequestInit): Promise<LearningContentProgress> => {

  return customFetch<LearningContentProgress>(getStartContentProgressUrl(id),
  {
    ...options,
    method: 'PUT'


  }
);}




export const getStartContentProgressMutationOptions = <TError = ErrorType<UnauthorizedResponse | LearningForbiddenResponse | LearningNotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startContentProgress>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof startContentProgress>>, TError,{id: string}, TContext> => {

const mutationKey = ['startContentProgress'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startContentProgress>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  startContentProgress(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartContentProgressMutationResult = NonNullable<Awaited<ReturnType<typeof startContentProgress>>>

    export type StartContentProgressMutationError = ErrorType<UnauthorizedResponse | LearningForbiddenResponse | LearningNotFoundResponse>

    /**
 * @summary Read or idempotently start the authenticated student's content progress
 */
export const useStartContentProgress = <TError = ErrorType<UnauthorizedResponse | LearningForbiddenResponse | LearningNotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startContentProgress>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof startContentProgress>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getStartContentProgressMutationOptions(options));
    }

export const getCompleteContentModuleUrl = (contentId: string,
    module: CompletableLearningModule,) => {




  return `/api/mobile/learning/contents/${contentId}/modules/${module}/complete`
}

/**
 * Accepts only BOX, MIND_MAP and SUMMARY. The first server timestamp is preserved and general content completion is not changed. Available only while learning_modules_enabled is active.
 * @summary Idempotently complete an existing reading module
 */
export const completeContentModule = async (contentId: string,
    module: CompletableLearningModule, options?: RequestInit): Promise<LearningContentProgress> => {

  return customFetch<LearningContentProgress>(getCompleteContentModuleUrl(contentId,module),
  {
    ...options,
    method: 'PUT'


  }
);}




export const getCompleteContentModuleMutationOptions = <TError = ErrorType<LearningBadRequestResponse | UnauthorizedResponse | LearningForbiddenResponse | LearningNotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeContentModule>>, TError,{contentId: string;module: CompletableLearningModule}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof completeContentModule>>, TError,{contentId: string;module: CompletableLearningModule}, TContext> => {

const mutationKey = ['completeContentModule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeContentModule>>, {contentId: string;module: CompletableLearningModule}> = (props) => {
          const {contentId,module} = props ?? {};

          return  completeContentModule(contentId,module,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteContentModuleMutationResult = NonNullable<Awaited<ReturnType<typeof completeContentModule>>>

    export type CompleteContentModuleMutationError = ErrorType<LearningBadRequestResponse | UnauthorizedResponse | LearningForbiddenResponse | LearningNotFoundResponse>

    /**
 * @summary Idempotently complete an existing reading module
 */
export const useCompleteContentModule = <TError = ErrorType<LearningBadRequestResponse | UnauthorizedResponse | LearningForbiddenResponse | LearningNotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeContentModule>>, TError,{contentId: string;module: CompletableLearningModule}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof completeContentModule>>,
        TError,
        {contentId: string;module: CompletableLearningModule},
        TContext
      > => {
      return useMutation(getCompleteContentModuleMutationOptions(options));
    }

export const getCompleteLearningContentUrl = (id: string,) => {




  return `/api/mobile/learning/contents/${id}/complete`
}

/**
 * Requires all five official module milestones. Completion is transactional, idempotent, and preserves the first database timestamp. Available only while learning_content_completion_enabled is active.
 * @summary Officially complete an authenticated student's content
 */
export const completeLearningContent = async (id: string, options?: RequestInit): Promise<LearningContentProgress> => {

  return customFetch<LearningContentProgress>(getCompleteLearningContentUrl(id),
  {
    ...options,
    method: 'PUT'


  }
);}




export const getCompleteLearningContentMutationOptions = <TError = ErrorType<UnauthorizedResponse | LearningForbiddenResponse | LearningNotFoundResponse | LearningContentIncompleteError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeLearningContent>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof completeLearningContent>>, TError,{id: string}, TContext> => {

const mutationKey = ['completeLearningContent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeLearningContent>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  completeLearningContent(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteLearningContentMutationResult = NonNullable<Awaited<ReturnType<typeof completeLearningContent>>>

    export type CompleteLearningContentMutationError = ErrorType<UnauthorizedResponse | LearningForbiddenResponse | LearningNotFoundResponse | LearningContentIncompleteError>

    /**
 * @summary Officially complete an authenticated student's content
 */
export const useCompleteLearningContent = <TError = ErrorType<UnauthorizedResponse | LearningForbiddenResponse | LearningNotFoundResponse | LearningContentIncompleteError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeLearningContent>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof completeLearningContent>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getCompleteLearningContentMutationOptions(options));
    }

export const getSubmitQuestionAttemptUrl = (questionId: number,) => {




  return `/api/mobile/learning/questions/${questionId}/attempts`
}

/**
 * The backend calculates isCorrect from the stored answer key. Reusing the same requestId returns the original official result. Available only while learning_attempts_enabled is active.
 * @summary Idempotently submit an authenticated student's question attempt
 */
export const submitQuestionAttempt = async (questionId: number,
    submitQuestionAttempt: SubmitQuestionAttempt, options?: RequestInit): Promise<QuestionAttemptResult> => {

  return customFetch<QuestionAttemptResult>(getSubmitQuestionAttemptUrl(questionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      submitQuestionAttempt,)
  }
);}




export const getSubmitQuestionAttemptMutationOptions = <TError = ErrorType<LearningBadRequestResponse | UnauthorizedResponse | LearningForbiddenResponse | LearningNotFoundResponse | LearningErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitQuestionAttempt>>, TError,{questionId: number;data: BodyType<SubmitQuestionAttempt>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitQuestionAttempt>>, TError,{questionId: number;data: BodyType<SubmitQuestionAttempt>}, TContext> => {

const mutationKey = ['submitQuestionAttempt'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitQuestionAttempt>>, {questionId: number;data: BodyType<SubmitQuestionAttempt>}> = (props) => {
          const {questionId,data} = props ?? {};

          return  submitQuestionAttempt(questionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitQuestionAttemptMutationResult = NonNullable<Awaited<ReturnType<typeof submitQuestionAttempt>>>
    export type SubmitQuestionAttemptMutationBody = BodyType<SubmitQuestionAttempt>
    export type SubmitQuestionAttemptMutationError = ErrorType<LearningBadRequestResponse | UnauthorizedResponse | LearningForbiddenResponse | LearningNotFoundResponse | LearningErrorResponse>

    /**
 * @summary Idempotently submit an authenticated student's question attempt
 */
export const useSubmitQuestionAttempt = <TError = ErrorType<LearningBadRequestResponse | UnauthorizedResponse | LearningForbiddenResponse | LearningNotFoundResponse | LearningErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitQuestionAttempt>>, TError,{questionId: number;data: BodyType<SubmitQuestionAttempt>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitQuestionAttempt>>,
        TError,
        {questionId: number;data: BodyType<SubmitQuestionAttempt>},
        TContext
      > => {
      return useMutation(getSubmitQuestionAttemptMutationOptions(options));
    }

export const getGetErrorNotebookUrl = (params?: GetErrorNotebookParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/mobile/learning/error-notebook?${stringifiedParams}` : `/api/mobile/learning/error-notebook`
}

/**
 * Derives ACTIVE and MASTERED cycles exclusively from official student_question_attempts. Available only while learning_error_notebook_enabled is active. It never returns answer keys or editorial snapshots.
 * @summary Get the authenticated student's official Error Notebook projection
 */
export const getErrorNotebook = async (params?: GetErrorNotebookParams, options?: RequestInit): Promise<ErrorNotebookResponse> => {

  return customFetch<ErrorNotebookResponse>(getGetErrorNotebookUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetErrorNotebookQueryKey = (params?: GetErrorNotebookParams,) => {
    return [
    `/api/mobile/learning/error-notebook`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetErrorNotebookQueryOptions = <TData = Awaited<ReturnType<typeof getErrorNotebook>>, TError = ErrorType<LearningBadRequestResponse | UnauthorizedResponse | LearningNotFoundResponse | LearningErrorResponse>>(params?: GetErrorNotebookParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getErrorNotebook>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetErrorNotebookQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getErrorNotebook>>> = ({ signal }) => getErrorNotebook(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getErrorNotebook>>, TError, TData> & { queryKey: QueryKey }
}

export type GetErrorNotebookQueryResult = NonNullable<Awaited<ReturnType<typeof getErrorNotebook>>>
export type GetErrorNotebookQueryError = ErrorType<LearningBadRequestResponse | UnauthorizedResponse | LearningNotFoundResponse | LearningErrorResponse>


/**
 * @summary Get the authenticated student's official Error Notebook projection
 */

export function useGetErrorNotebook<TData = Awaited<ReturnType<typeof getErrorNotebook>>, TError = ErrorType<LearningBadRequestResponse | UnauthorizedResponse | LearningNotFoundResponse | LearningErrorResponse>>(
 params?: GetErrorNotebookParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getErrorNotebook>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetErrorNotebookQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetErrorNotebookQuestionsUrl = () => {




  return `/api/mobile/learning/error-notebook/questions`
}

/**
 * Returns only active questions whose parent content is active and accessible to the authenticated student. It never returns the answer key.
 * @summary Load authorized editorial data for Error Notebook questions in one batch
 */
export const getErrorNotebookQuestions = async (errorNotebookQuestionsInput: ErrorNotebookQuestionsInput, options?: RequestInit): Promise<ErrorNotebookQuestionsResponse> => {

  return customFetch<ErrorNotebookQuestionsResponse>(getGetErrorNotebookQuestionsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      errorNotebookQuestionsInput,)
  }
);}




export const getGetErrorNotebookQuestionsMutationOptions = <TError = ErrorType<LearningBadRequestResponse | UnauthorizedResponse | LearningNotFoundResponse | LearningErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getErrorNotebookQuestions>>, TError,{data: BodyType<ErrorNotebookQuestionsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof getErrorNotebookQuestions>>, TError,{data: BodyType<ErrorNotebookQuestionsInput>}, TContext> => {

const mutationKey = ['getErrorNotebookQuestions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getErrorNotebookQuestions>>, {data: BodyType<ErrorNotebookQuestionsInput>}> = (props) => {
          const {data} = props ?? {};

          return  getErrorNotebookQuestions(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetErrorNotebookQuestionsMutationResult = NonNullable<Awaited<ReturnType<typeof getErrorNotebookQuestions>>>
    export type GetErrorNotebookQuestionsMutationBody = BodyType<ErrorNotebookQuestionsInput>
    export type GetErrorNotebookQuestionsMutationError = ErrorType<LearningBadRequestResponse | UnauthorizedResponse | LearningNotFoundResponse | LearningErrorResponse>

    /**
 * @summary Load authorized editorial data for Error Notebook questions in one batch
 */
export const useGetErrorNotebookQuestions = <TError = ErrorType<LearningBadRequestResponse | UnauthorizedResponse | LearningNotFoundResponse | LearningErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getErrorNotebookQuestions>>, TError,{data: BodyType<ErrorNotebookQuestionsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof getErrorNotebookQuestions>>,
        TError,
        {data: BodyType<ErrorNotebookQuestionsInput>},
        TContext
      > => {
      return useMutation(getGetErrorNotebookQuestionsMutationOptions(options));
    }

export const getGetMobileConteudoBlocosUrl = (id: string,
    modulo: 'RESUMO' | 'MAPA_MENTAL' | 'BOX_ESTRATEGICO',) => {




  return `/api/mobile/conteudos/${id}/blocos/${modulo}`
}

/**
 * @summary Get content blocks, including summary and mental-map modules
 */
export const getMobileConteudoBlocos = async (id: string,
    modulo: 'RESUMO' | 'MAPA_MENTAL' | 'BOX_ESTRATEGICO', options?: RequestInit): Promise<MobileBlocosResponse> => {

  return customFetch<MobileBlocosResponse>(getGetMobileConteudoBlocosUrl(id,modulo),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMobileConteudoBlocosQueryKey = (id: string,
    modulo: 'RESUMO' | 'MAPA_MENTAL' | 'BOX_ESTRATEGICO',) => {
    return [
    `/api/mobile/conteudos/${id}/blocos/${modulo}`
    ] as const;
    }


export const getGetMobileConteudoBlocosQueryOptions = <TData = Awaited<ReturnType<typeof getMobileConteudoBlocos>>, TError = ErrorType<UnauthorizedResponse | PremiumRequiredResponse | ContentNotFoundResponse>>(id: string,
    modulo: 'RESUMO' | 'MAPA_MENTAL' | 'BOX_ESTRATEGICO', options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMobileConteudoBlocos>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMobileConteudoBlocosQueryKey(id,modulo);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMobileConteudoBlocos>>> = ({ signal }) => getMobileConteudoBlocos(id,modulo, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id && modulo), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMobileConteudoBlocos>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMobileConteudoBlocosQueryResult = NonNullable<Awaited<ReturnType<typeof getMobileConteudoBlocos>>>
export type GetMobileConteudoBlocosQueryError = ErrorType<UnauthorizedResponse | PremiumRequiredResponse | ContentNotFoundResponse>


/**
 * @summary Get content blocks, including summary and mental-map modules
 */

export function useGetMobileConteudoBlocos<TData = Awaited<ReturnType<typeof getMobileConteudoBlocos>>, TError = ErrorType<UnauthorizedResponse | PremiumRequiredResponse | ContentNotFoundResponse>>(
 id: string,
    modulo: 'RESUMO' | 'MAPA_MENTAL' | 'BOX_ESTRATEGICO', options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMobileConteudoBlocos>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMobileConteudoBlocosQueryOptions(id,modulo,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListMobileConteudoQuestoesUrl = (id: string,) => {




  return `/api/mobile/conteudos/${id}/questoes`
}

/**
 * @deprecated
 * @summary Removed insecure legacy question endpoint
 */
export const listMobileConteudoQuestoes = async (id: string, options?: RequestInit): Promise<unknown> => {

  return customFetch<unknown>(getListMobileConteudoQuestoesUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMobileConteudoQuestoesQueryKey = (id: string,) => {
    return [
    `/api/mobile/conteudos/${id}/questoes`
    ] as const;
    }


export const getListMobileConteudoQuestoesQueryOptions = <TData = Awaited<ReturnType<typeof listMobileConteudoQuestoes>>, TError = ErrorType<LegacyQuestionEndpointGoneResponse>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMobileConteudoQuestoes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMobileConteudoQuestoesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMobileConteudoQuestoes>>> = ({ signal }) => listMobileConteudoQuestoes(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMobileConteudoQuestoes>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMobileConteudoQuestoesQueryResult = NonNullable<Awaited<ReturnType<typeof listMobileConteudoQuestoes>>>
export type ListMobileConteudoQuestoesQueryError = ErrorType<LegacyQuestionEndpointGoneResponse>


/**
 * @deprecated
 * @summary Removed insecure legacy question endpoint
 */

export function useListMobileConteudoQuestoes<TData = Awaited<ReturnType<typeof listMobileConteudoQuestoes>>, TError = ErrorType<LegacyQuestionEndpointGoneResponse>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMobileConteudoQuestoes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMobileConteudoQuestoesQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListMobileQuestoesUrl = () => {




  return `/api/mobile/questoes`
}

/**
 * @deprecated
 * @summary Removed insecure unpaginated question endpoint
 */
export const listMobileQuestoes = async ( options?: RequestInit): Promise<unknown> => {

  return customFetch<unknown>(getListMobileQuestoesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMobileQuestoesQueryKey = () => {
    return [
    `/api/mobile/questoes`
    ] as const;
    }


export const getListMobileQuestoesQueryOptions = <TData = Awaited<ReturnType<typeof listMobileQuestoes>>, TError = ErrorType<LegacyQuestionEndpointGoneResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMobileQuestoes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMobileQuestoesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMobileQuestoes>>> = ({ signal }) => listMobileQuestoes({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMobileQuestoes>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMobileQuestoesQueryResult = NonNullable<Awaited<ReturnType<typeof listMobileQuestoes>>>
export type ListMobileQuestoesQueryError = ErrorType<LegacyQuestionEndpointGoneResponse>


/**
 * @deprecated
 * @summary Removed insecure unpaginated question endpoint
 */

export function useListMobileQuestoes<TData = Awaited<ReturnType<typeof listMobileQuestoes>>, TError = ErrorType<LegacyQuestionEndpointGoneResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMobileQuestoes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMobileQuestoesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListFavoritesUrl = (params?: ListFavoritesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/mobile/favorites?${stringifiedParams}` : `/api/mobile/favorites`
}

/**
 * Cursor-paginated by favoritedAt and technical ID. Inactive or currently inaccessible questions are omitted without deleting the stored link.
 * @summary List the authenticated student's visible favorite questions
 */
export const listFavorites = async (params?: ListFavoritesParams, options?: RequestInit): Promise<FavoriteListResponse> => {

  return customFetch<FavoriteListResponse>(getListFavoritesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListFavoritesQueryKey = (params?: ListFavoritesParams,) => {
    return [
    `/api/mobile/favorites`, ...(params ? [params] : [])
    ] as const;
    }


export const getListFavoritesQueryOptions = <TData = Awaited<ReturnType<typeof listFavorites>>, TError = ErrorType<ValidationErrorResponse | UnauthorizedResponse>>(params?: ListFavoritesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listFavorites>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListFavoritesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFavorites>>> = ({ signal }) => listFavorites(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listFavorites>>, TError, TData> & { queryKey: QueryKey }
}

export type ListFavoritesQueryResult = NonNullable<Awaited<ReturnType<typeof listFavorites>>>
export type ListFavoritesQueryError = ErrorType<ValidationErrorResponse | UnauthorizedResponse>


/**
 * @summary List the authenticated student's visible favorite questions
 */

export function useListFavorites<TData = Awaited<ReturnType<typeof listFavorites>>, TError = ErrorType<ValidationErrorResponse | UnauthorizedResponse>>(
 params?: ListFavoritesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listFavorites>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListFavoritesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCountFavoritesUrl = () => {




  return `/api/mobile/favorites/count`
}

/**
 * @summary Count the authenticated student's currently visible favorites
 */
export const countFavorites = async ( options?: RequestInit): Promise<FavoriteCount> => {

  return customFetch<FavoriteCount>(getCountFavoritesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCountFavoritesQueryKey = () => {
    return [
    `/api/mobile/favorites/count`
    ] as const;
    }


export const getCountFavoritesQueryOptions = <TData = Awaited<ReturnType<typeof countFavorites>>, TError = ErrorType<UnauthorizedResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof countFavorites>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCountFavoritesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof countFavorites>>> = ({ signal }) => countFavorites({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof countFavorites>>, TError, TData> & { queryKey: QueryKey }
}

export type CountFavoritesQueryResult = NonNullable<Awaited<ReturnType<typeof countFavorites>>>
export type CountFavoritesQueryError = ErrorType<UnauthorizedResponse>


/**
 * @summary Count the authenticated student's currently visible favorites
 */

export function useCountFavorites<TData = Awaited<ReturnType<typeof countFavorites>>, TError = ErrorType<UnauthorizedResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof countFavorites>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getCountFavoritesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetFavoriteStatesUrl = () => {




  return `/api/mobile/questions/favorite-states`
}

/**
 * @summary Resolve favorite state for up to 100 question IDs in one query
 */
export const getFavoriteStates = async (favoriteStatesInput: FavoriteStatesInput, options?: RequestInit): Promise<FavoriteStatesResponse> => {

  return customFetch<FavoriteStatesResponse>(getGetFavoriteStatesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      favoriteStatesInput,)
  }
);}




export const getGetFavoriteStatesMutationOptions = <TError = ErrorType<ValidationErrorResponse | UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getFavoriteStates>>, TError,{data: BodyType<FavoriteStatesInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof getFavoriteStates>>, TError,{data: BodyType<FavoriteStatesInput>}, TContext> => {

const mutationKey = ['getFavoriteStates'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getFavoriteStates>>, {data: BodyType<FavoriteStatesInput>}> = (props) => {
          const {data} = props ?? {};

          return  getFavoriteStates(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetFavoriteStatesMutationResult = NonNullable<Awaited<ReturnType<typeof getFavoriteStates>>>
    export type GetFavoriteStatesMutationBody = BodyType<FavoriteStatesInput>
    export type GetFavoriteStatesMutationError = ErrorType<ValidationErrorResponse | UnauthorizedResponse>

    /**
 * @summary Resolve favorite state for up to 100 question IDs in one query
 */
export const useGetFavoriteStates = <TError = ErrorType<ValidationErrorResponse | UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getFavoriteStates>>, TError,{data: BodyType<FavoriteStatesInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof getFavoriteStates>>,
        TError,
        {data: BodyType<FavoriteStatesInput>},
        TContext
      > => {
      return useMutation(getGetFavoriteStatesMutationOptions(options));
    }

export const getAddFavoriteUrl = (questionId: number,) => {




  return `/api/mobile/questions/${questionId}/favorite`
}

/**
 * @summary Idempotently favorite a discoverable active question
 */
export const addFavorite = async (questionId: number, options?: RequestInit): Promise<FavoriteMutationResult> => {

  return customFetch<FavoriteMutationResult>(getAddFavoriteUrl(questionId),
  {
    ...options,
    method: 'PUT'


  }
);}




export const getAddFavoriteMutationOptions = <TError = ErrorType<ValidationErrorResponse | UnauthorizedResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addFavorite>>, TError,{questionId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addFavorite>>, TError,{questionId: number}, TContext> => {

const mutationKey = ['addFavorite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addFavorite>>, {questionId: number}> = (props) => {
          const {questionId} = props ?? {};

          return  addFavorite(questionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddFavoriteMutationResult = NonNullable<Awaited<ReturnType<typeof addFavorite>>>

    export type AddFavoriteMutationError = ErrorType<ValidationErrorResponse | UnauthorizedResponse | void>

    /**
 * @summary Idempotently favorite a discoverable active question
 */
export const useAddFavorite = <TError = ErrorType<ValidationErrorResponse | UnauthorizedResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addFavorite>>, TError,{questionId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addFavorite>>,
        TError,
        {questionId: number},
        TContext
      > => {
      return useMutation(getAddFavoriteMutationOptions(options));
    }

export const getRemoveFavoriteUrl = (questionId: number,) => {




  return `/api/mobile/questions/${questionId}/favorite`
}

/**
 * @summary Idempotently remove the authenticated student's favorite link
 */
export const removeFavorite = async (questionId: number, options?: RequestInit): Promise<FavoriteMutationResult> => {

  return customFetch<FavoriteMutationResult>(getRemoveFavoriteUrl(questionId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getRemoveFavoriteMutationOptions = <TError = ErrorType<ValidationErrorResponse | UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeFavorite>>, TError,{questionId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeFavorite>>, TError,{questionId: number}, TContext> => {

const mutationKey = ['removeFavorite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeFavorite>>, {questionId: number}> = (props) => {
          const {questionId} = props ?? {};

          return  removeFavorite(questionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveFavoriteMutationResult = NonNullable<Awaited<ReturnType<typeof removeFavorite>>>

    export type RemoveFavoriteMutationError = ErrorType<ValidationErrorResponse | UnauthorizedResponse>

    /**
 * @summary Idempotently remove the authenticated student's favorite link
 */
export const useRemoveFavorite = <TError = ErrorType<ValidationErrorResponse | UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeFavorite>>, TError,{questionId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof removeFavorite>>,
        TError,
        {questionId: number},
        TContext
      > => {
      return useMutation(getRemoveFavoriteMutationOptions(options));
    }

export const getGetFavoriteStateUrl = (questionId: number,) => {




  return `/api/mobile/questions/${questionId}/favorite`
}

/**
 * @summary Get favorite state for one discoverable question
 */
export const getFavoriteState = async (questionId: number, options?: RequestInit): Promise<FavoriteState> => {

  return customFetch<FavoriteState>(getGetFavoriteStateUrl(questionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetFavoriteStateQueryKey = (questionId: number,) => {
    return [
    `/api/mobile/questions/${questionId}/favorite`
    ] as const;
    }


export const getGetFavoriteStateQueryOptions = <TData = Awaited<ReturnType<typeof getFavoriteState>>, TError = ErrorType<ValidationErrorResponse | UnauthorizedResponse | void>>(questionId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFavoriteState>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFavoriteStateQueryKey(questionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFavoriteState>>> = ({ signal }) => getFavoriteState(questionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(questionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFavoriteState>>, TError, TData> & { queryKey: QueryKey }
}

export type GetFavoriteStateQueryResult = NonNullable<Awaited<ReturnType<typeof getFavoriteState>>>
export type GetFavoriteStateQueryError = ErrorType<ValidationErrorResponse | UnauthorizedResponse | void>


/**
 * @summary Get favorite state for one discoverable question
 */

export function useGetFavoriteState<TData = Awaited<ReturnType<typeof getFavoriteState>>, TError = ErrorType<ValidationErrorResponse | UnauthorizedResponse | void>>(
 questionId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFavoriteState>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetFavoriteStateQueryOptions(questionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListQuestionNotebooksUrl = (params?: ListQuestionNotebooksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/mobile/notebooks?${stringifiedParams}` : `/api/mobile/notebooks`
}

export const listQuestionNotebooks = async (params?: ListQuestionNotebooksParams, options?: RequestInit): Promise<QuestionNotebookListResponse> => {

  return customFetch<QuestionNotebookListResponse>(getListQuestionNotebooksUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListQuestionNotebooksQueryKey = (params?: ListQuestionNotebooksParams,) => {
    return [
    `/api/mobile/notebooks`, ...(params ? [params] : [])
    ] as const;
    }


export const getListQuestionNotebooksQueryOptions = <TData = Awaited<ReturnType<typeof listQuestionNotebooks>>, TError = ErrorType<ValidationErrorResponse | UnauthorizedResponse>>(params?: ListQuestionNotebooksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listQuestionNotebooks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQuestionNotebooksQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuestionNotebooks>>> = ({ signal }) => listQuestionNotebooks(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listQuestionNotebooks>>, TError, TData> & { queryKey: QueryKey }
}

export type ListQuestionNotebooksQueryResult = NonNullable<Awaited<ReturnType<typeof listQuestionNotebooks>>>
export type ListQuestionNotebooksQueryError = ErrorType<ValidationErrorResponse | UnauthorizedResponse>



export function useListQuestionNotebooks<TData = Awaited<ReturnType<typeof listQuestionNotebooks>>, TError = ErrorType<ValidationErrorResponse | UnauthorizedResponse>>(
 params?: ListQuestionNotebooksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listQuestionNotebooks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListQuestionNotebooksQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateQuestionNotebookUrl = () => {




  return `/api/mobile/notebooks`
}

export const createQuestionNotebook = async (questionNotebookInput: QuestionNotebookInput, options?: RequestInit): Promise<QuestionNotebook> => {

  return customFetch<QuestionNotebook>(getCreateQuestionNotebookUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      questionNotebookInput,)
  }
);}




export const getCreateQuestionNotebookMutationOptions = <TError = ErrorType<ValidationErrorResponse | UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createQuestionNotebook>>, TError,{data: BodyType<QuestionNotebookInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createQuestionNotebook>>, TError,{data: BodyType<QuestionNotebookInput>}, TContext> => {

const mutationKey = ['createQuestionNotebook'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createQuestionNotebook>>, {data: BodyType<QuestionNotebookInput>}> = (props) => {
          const {data} = props ?? {};

          return  createQuestionNotebook(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateQuestionNotebookMutationResult = NonNullable<Awaited<ReturnType<typeof createQuestionNotebook>>>
    export type CreateQuestionNotebookMutationBody = BodyType<QuestionNotebookInput>
    export type CreateQuestionNotebookMutationError = ErrorType<ValidationErrorResponse | UnauthorizedResponse>

    export const useCreateQuestionNotebook = <TError = ErrorType<ValidationErrorResponse | UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createQuestionNotebook>>, TError,{data: BodyType<QuestionNotebookInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createQuestionNotebook>>,
        TError,
        {data: BodyType<QuestionNotebookInput>},
        TContext
      > => {
      return useMutation(getCreateQuestionNotebookMutationOptions(options));
    }

export const getGetQuestionNotebookUrl = (id: number,) => {




  return `/api/mobile/notebooks/${id}`
}

export const getQuestionNotebook = async (id: number, options?: RequestInit): Promise<QuestionNotebook> => {

  return customFetch<QuestionNotebook>(getGetQuestionNotebookUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetQuestionNotebookQueryKey = (id: number,) => {
    return [
    `/api/mobile/notebooks/${id}`
    ] as const;
    }


export const getGetQuestionNotebookQueryOptions = <TData = Awaited<ReturnType<typeof getQuestionNotebook>>, TError = ErrorType<UnauthorizedResponse | void>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQuestionNotebook>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuestionNotebookQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuestionNotebook>>> = ({ signal }) => getQuestionNotebook(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQuestionNotebook>>, TError, TData> & { queryKey: QueryKey }
}

export type GetQuestionNotebookQueryResult = NonNullable<Awaited<ReturnType<typeof getQuestionNotebook>>>
export type GetQuestionNotebookQueryError = ErrorType<UnauthorizedResponse | void>



export function useGetQuestionNotebook<TData = Awaited<ReturnType<typeof getQuestionNotebook>>, TError = ErrorType<UnauthorizedResponse | void>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQuestionNotebook>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetQuestionNotebookQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateQuestionNotebookUrl = (id: number,) => {




  return `/api/mobile/notebooks/${id}`
}

export const updateQuestionNotebook = async (id: number,
    questionNotebookUpdate: QuestionNotebookUpdate, options?: RequestInit): Promise<QuestionNotebook> => {

  return customFetch<QuestionNotebook>(getUpdateQuestionNotebookUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      questionNotebookUpdate,)
  }
);}




export const getUpdateQuestionNotebookMutationOptions = <TError = ErrorType<ValidationErrorResponse | UnauthorizedResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateQuestionNotebook>>, TError,{id: number;data: BodyType<QuestionNotebookUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateQuestionNotebook>>, TError,{id: number;data: BodyType<QuestionNotebookUpdate>}, TContext> => {

const mutationKey = ['updateQuestionNotebook'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateQuestionNotebook>>, {id: number;data: BodyType<QuestionNotebookUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateQuestionNotebook(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateQuestionNotebookMutationResult = NonNullable<Awaited<ReturnType<typeof updateQuestionNotebook>>>
    export type UpdateQuestionNotebookMutationBody = BodyType<QuestionNotebookUpdate>
    export type UpdateQuestionNotebookMutationError = ErrorType<ValidationErrorResponse | UnauthorizedResponse | void>

    export const useUpdateQuestionNotebook = <TError = ErrorType<ValidationErrorResponse | UnauthorizedResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateQuestionNotebook>>, TError,{id: number;data: BodyType<QuestionNotebookUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateQuestionNotebook>>,
        TError,
        {id: number;data: BodyType<QuestionNotebookUpdate>},
        TContext
      > => {
      return useMutation(getUpdateQuestionNotebookMutationOptions(options));
    }

export const getDeleteQuestionNotebookUrl = (id: number,) => {




  return `/api/mobile/notebooks/${id}`
}

export const deleteQuestionNotebook = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteQuestionNotebookUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteQuestionNotebookMutationOptions = <TError = ErrorType<UnauthorizedResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteQuestionNotebook>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteQuestionNotebook>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteQuestionNotebook'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteQuestionNotebook>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteQuestionNotebook(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteQuestionNotebookMutationResult = NonNullable<Awaited<ReturnType<typeof deleteQuestionNotebook>>>

    export type DeleteQuestionNotebookMutationError = ErrorType<UnauthorizedResponse | void>

    export const useDeleteQuestionNotebook = <TError = ErrorType<UnauthorizedResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteQuestionNotebook>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteQuestionNotebook>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteQuestionNotebookMutationOptions(options));
    }

export const getGetQuestionNotebookStatsUrl = (id: number,) => {




  return `/api/mobile/notebooks/${id}/stats`
}

export const getQuestionNotebookStats = async (id: number, options?: RequestInit): Promise<QuestionNotebookStats> => {

  return customFetch<QuestionNotebookStats>(getGetQuestionNotebookStatsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetQuestionNotebookStatsQueryKey = (id: number,) => {
    return [
    `/api/mobile/notebooks/${id}/stats`
    ] as const;
    }


export const getGetQuestionNotebookStatsQueryOptions = <TData = Awaited<ReturnType<typeof getQuestionNotebookStats>>, TError = ErrorType<UnauthorizedResponse | void>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQuestionNotebookStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuestionNotebookStatsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuestionNotebookStats>>> = ({ signal }) => getQuestionNotebookStats(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQuestionNotebookStats>>, TError, TData> & { queryKey: QueryKey }
}

export type GetQuestionNotebookStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getQuestionNotebookStats>>>
export type GetQuestionNotebookStatsQueryError = ErrorType<UnauthorizedResponse | void>



export function useGetQuestionNotebookStats<TData = Awaited<ReturnType<typeof getQuestionNotebookStats>>, TError = ErrorType<UnauthorizedResponse | void>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQuestionNotebookStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetQuestionNotebookStatsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListQuestionNotebookQuestionsUrl = (id: number,
    params?: ListQuestionNotebookQuestionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/mobile/notebooks/${id}/questions?${stringifiedParams}` : `/api/mobile/notebooks/${id}/questions`
}

export const listQuestionNotebookQuestions = async (id: number,
    params?: ListQuestionNotebookQuestionsParams, options?: RequestInit): Promise<QuestionNotebookItemsResponse> => {

  return customFetch<QuestionNotebookItemsResponse>(getListQuestionNotebookQuestionsUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListQuestionNotebookQuestionsQueryKey = (id: number,
    params?: ListQuestionNotebookQuestionsParams,) => {
    return [
    `/api/mobile/notebooks/${id}/questions`, ...(params ? [params] : [])
    ] as const;
    }


export const getListQuestionNotebookQuestionsQueryOptions = <TData = Awaited<ReturnType<typeof listQuestionNotebookQuestions>>, TError = ErrorType<ValidationErrorResponse | UnauthorizedResponse | void>>(id: number,
    params?: ListQuestionNotebookQuestionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listQuestionNotebookQuestions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQuestionNotebookQuestionsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuestionNotebookQuestions>>> = ({ signal }) => listQuestionNotebookQuestions(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listQuestionNotebookQuestions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListQuestionNotebookQuestionsQueryResult = NonNullable<Awaited<ReturnType<typeof listQuestionNotebookQuestions>>>
export type ListQuestionNotebookQuestionsQueryError = ErrorType<ValidationErrorResponse | UnauthorizedResponse | void>



export function useListQuestionNotebookQuestions<TData = Awaited<ReturnType<typeof listQuestionNotebookQuestions>>, TError = ErrorType<ValidationErrorResponse | UnauthorizedResponse | void>>(
 id: number,
    params?: ListQuestionNotebookQuestionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listQuestionNotebookQuestions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListQuestionNotebookQuestionsQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getAddQuestionNotebookQuestionUrl = (id: number,) => {




  return `/api/mobile/notebooks/${id}/questions`
}

export const addQuestionNotebookQuestion = async (id: number,
    questionNotebookQuestionInput: QuestionNotebookQuestionInput, options?: RequestInit): Promise<QuestionNotebookMutationResult> => {

  return customFetch<QuestionNotebookMutationResult>(getAddQuestionNotebookQuestionUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      questionNotebookQuestionInput,)
  }
);}




export const getAddQuestionNotebookQuestionMutationOptions = <TError = ErrorType<ValidationErrorResponse | UnauthorizedResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addQuestionNotebookQuestion>>, TError,{id: number;data: BodyType<QuestionNotebookQuestionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addQuestionNotebookQuestion>>, TError,{id: number;data: BodyType<QuestionNotebookQuestionInput>}, TContext> => {

const mutationKey = ['addQuestionNotebookQuestion'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addQuestionNotebookQuestion>>, {id: number;data: BodyType<QuestionNotebookQuestionInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  addQuestionNotebookQuestion(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddQuestionNotebookQuestionMutationResult = NonNullable<Awaited<ReturnType<typeof addQuestionNotebookQuestion>>>
    export type AddQuestionNotebookQuestionMutationBody = BodyType<QuestionNotebookQuestionInput>
    export type AddQuestionNotebookQuestionMutationError = ErrorType<ValidationErrorResponse | UnauthorizedResponse | void>

    export const useAddQuestionNotebookQuestion = <TError = ErrorType<ValidationErrorResponse | UnauthorizedResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addQuestionNotebookQuestion>>, TError,{id: number;data: BodyType<QuestionNotebookQuestionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addQuestionNotebookQuestion>>,
        TError,
        {id: number;data: BodyType<QuestionNotebookQuestionInput>},
        TContext
      > => {
      return useMutation(getAddQuestionNotebookQuestionMutationOptions(options));
    }

export const getRemoveQuestionNotebookQuestionUrl = (id: number,
    questionId: number,) => {




  return `/api/mobile/notebooks/${id}/questions/${questionId}`
}

export const removeQuestionNotebookQuestion = async (id: number,
    questionId: number, options?: RequestInit): Promise<QuestionNotebookMutationResult> => {

  return customFetch<QuestionNotebookMutationResult>(getRemoveQuestionNotebookQuestionUrl(id,questionId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getRemoveQuestionNotebookQuestionMutationOptions = <TError = ErrorType<ValidationErrorResponse | UnauthorizedResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeQuestionNotebookQuestion>>, TError,{id: number;questionId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeQuestionNotebookQuestion>>, TError,{id: number;questionId: number}, TContext> => {

const mutationKey = ['removeQuestionNotebookQuestion'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeQuestionNotebookQuestion>>, {id: number;questionId: number}> = (props) => {
          const {id,questionId} = props ?? {};

          return  removeQuestionNotebookQuestion(id,questionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveQuestionNotebookQuestionMutationResult = NonNullable<Awaited<ReturnType<typeof removeQuestionNotebookQuestion>>>

    export type RemoveQuestionNotebookQuestionMutationError = ErrorType<ValidationErrorResponse | UnauthorizedResponse | void>

    export const useRemoveQuestionNotebookQuestion = <TError = ErrorType<ValidationErrorResponse | UnauthorizedResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeQuestionNotebookQuestion>>, TError,{id: number;questionId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof removeQuestionNotebookQuestion>>,
        TError,
        {id: number;questionId: number},
        TContext
      > => {
      return useMutation(getRemoveQuestionNotebookQuestionMutationOptions(options));
    }

export const getListSimulationsUrl = (params?: ListSimulationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/mobile/simulations?${stringifiedParams}` : `/api/mobile/simulations`
}

export const listSimulations = async (params?: ListSimulationsParams, options?: RequestInit): Promise<SimulationList> => {

  return customFetch<SimulationList>(getListSimulationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSimulationsQueryKey = (params?: ListSimulationsParams,) => {
    return [
    `/api/mobile/simulations`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSimulationsQueryOptions = <TData = Awaited<ReturnType<typeof listSimulations>>, TError = ErrorType<UnauthorizedResponse>>(params?: ListSimulationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSimulations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSimulationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSimulations>>> = ({ signal }) => listSimulations(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSimulations>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSimulationsQueryResult = NonNullable<Awaited<ReturnType<typeof listSimulations>>>
export type ListSimulationsQueryError = ErrorType<UnauthorizedResponse>



export function useListSimulations<TData = Awaited<ReturnType<typeof listSimulations>>, TError = ErrorType<UnauthorizedResponse>>(
 params?: ListSimulationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSimulations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSimulationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateSimulationUrl = () => {




  return `/api/mobile/simulations`
}

export const createSimulation = async (simulationInput: SimulationInput, options?: RequestInit): Promise<SimulationDetails> => {

  return customFetch<SimulationDetails>(getCreateSimulationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      simulationInput,)
  }
);}




export const getCreateSimulationMutationOptions = <TError = ErrorType<ValidationErrorResponse | UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSimulation>>, TError,{data: BodyType<SimulationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSimulation>>, TError,{data: BodyType<SimulationInput>}, TContext> => {

const mutationKey = ['createSimulation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSimulation>>, {data: BodyType<SimulationInput>}> = (props) => {
          const {data} = props ?? {};

          return  createSimulation(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSimulationMutationResult = NonNullable<Awaited<ReturnType<typeof createSimulation>>>
    export type CreateSimulationMutationBody = BodyType<SimulationInput>
    export type CreateSimulationMutationError = ErrorType<ValidationErrorResponse | UnauthorizedResponse>

    export const useCreateSimulation = <TError = ErrorType<ValidationErrorResponse | UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSimulation>>, TError,{data: BodyType<SimulationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSimulation>>,
        TError,
        {data: BodyType<SimulationInput>},
        TContext
      > => {
      return useMutation(getCreateSimulationMutationOptions(options));
    }

export const getGetSimulationUrl = (id: number,) => {




  return `/api/mobile/simulations/${id}`
}

export const getSimulation = async (id: number, options?: RequestInit): Promise<SimulationDetails> => {

  return customFetch<SimulationDetails>(getGetSimulationUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSimulationQueryKey = (id: number,) => {
    return [
    `/api/mobile/simulations/${id}`
    ] as const;
    }


export const getGetSimulationQueryOptions = <TData = Awaited<ReturnType<typeof getSimulation>>, TError = ErrorType<void>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSimulation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimulationQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimulation>>> = ({ signal }) => getSimulation(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSimulation>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSimulationQueryResult = NonNullable<Awaited<ReturnType<typeof getSimulation>>>
export type GetSimulationQueryError = ErrorType<void>



export function useGetSimulation<TData = Awaited<ReturnType<typeof getSimulation>>, TError = ErrorType<void>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSimulation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSimulationQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateSimulationUrl = (id: number,) => {




  return `/api/mobile/simulations/${id}`
}

export const updateSimulation = async (id: number,
    updateSimulationBody: UpdateSimulationBody, options?: RequestInit): Promise<Simulation> => {

  return customFetch<Simulation>(getUpdateSimulationUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateSimulationBody,)
  }
);}




export const getUpdateSimulationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSimulation>>, TError,{id: number;data: BodyType<UpdateSimulationBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSimulation>>, TError,{id: number;data: BodyType<UpdateSimulationBody>}, TContext> => {

const mutationKey = ['updateSimulation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSimulation>>, {id: number;data: BodyType<UpdateSimulationBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateSimulation(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSimulationMutationResult = NonNullable<Awaited<ReturnType<typeof updateSimulation>>>
    export type UpdateSimulationMutationBody = BodyType<UpdateSimulationBody>
    export type UpdateSimulationMutationError = ErrorType<unknown>

    export const useUpdateSimulation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSimulation>>, TError,{id: number;data: BodyType<UpdateSimulationBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSimulation>>,
        TError,
        {id: number;data: BodyType<UpdateSimulationBody>},
        TContext
      > => {
      return useMutation(getUpdateSimulationMutationOptions(options));
    }

export const getDeleteSimulationUrl = (id: number,) => {




  return `/api/mobile/simulations/${id}`
}

export const deleteSimulation = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteSimulationUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteSimulationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSimulation>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSimulation>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteSimulation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSimulation>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteSimulation(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSimulationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSimulation>>>

    export type DeleteSimulationMutationError = ErrorType<unknown>

    export const useDeleteSimulation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSimulation>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteSimulation>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteSimulationMutationOptions(options));
    }

export const getStartSimulationUrl = (id: number,) => {




  return `/api/mobile/simulations/${id}/start`
}

export const startSimulation = async (id: number, options?: RequestInit): Promise<SimulationRun> => {

  return customFetch<SimulationRun>(getStartSimulationUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getStartSimulationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startSimulation>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof startSimulation>>, TError,{id: number}, TContext> => {

const mutationKey = ['startSimulation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startSimulation>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  startSimulation(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartSimulationMutationResult = NonNullable<Awaited<ReturnType<typeof startSimulation>>>

    export type StartSimulationMutationError = ErrorType<unknown>

    export const useStartSimulation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startSimulation>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof startSimulation>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getStartSimulationMutationOptions(options));
    }

export const getPauseSimulationUrl = (id: number,) => {




  return `/api/mobile/simulations/${id}/pause`
}

export const pauseSimulation = async (id: number, options?: RequestInit): Promise<SimulationRun> => {

  return customFetch<SimulationRun>(getPauseSimulationUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPauseSimulationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pauseSimulation>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof pauseSimulation>>, TError,{id: number}, TContext> => {

const mutationKey = ['pauseSimulation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pauseSimulation>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  pauseSimulation(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PauseSimulationMutationResult = NonNullable<Awaited<ReturnType<typeof pauseSimulation>>>

    export type PauseSimulationMutationError = ErrorType<unknown>

    export const usePauseSimulation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pauseSimulation>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof pauseSimulation>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getPauseSimulationMutationOptions(options));
    }

export const getResumeSimulationUrl = (id: number,) => {




  return `/api/mobile/simulations/${id}/resume`
}

export const resumeSimulation = async (id: number, options?: RequestInit): Promise<SimulationRun> => {

  return customFetch<SimulationRun>(getResumeSimulationUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getResumeSimulationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resumeSimulation>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resumeSimulation>>, TError,{id: number}, TContext> => {

const mutationKey = ['resumeSimulation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resumeSimulation>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  resumeSimulation(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResumeSimulationMutationResult = NonNullable<Awaited<ReturnType<typeof resumeSimulation>>>

    export type ResumeSimulationMutationError = ErrorType<unknown>

    export const useResumeSimulation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resumeSimulation>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof resumeSimulation>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getResumeSimulationMutationOptions(options));
    }

export const getFinishSimulationUrl = (id: number,) => {




  return `/api/mobile/simulations/${id}/finish`
}

export const finishSimulation = async (id: number, options?: RequestInit): Promise<SimulationRun> => {

  return customFetch<SimulationRun>(getFinishSimulationUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getFinishSimulationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finishSimulation>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof finishSimulation>>, TError,{id: number}, TContext> => {

const mutationKey = ['finishSimulation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof finishSimulation>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  finishSimulation(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FinishSimulationMutationResult = NonNullable<Awaited<ReturnType<typeof finishSimulation>>>

    export type FinishSimulationMutationError = ErrorType<unknown>

    export const useFinishSimulation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finishSimulation>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof finishSimulation>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getFinishSimulationMutationOptions(options));
    }

export const getGetSimulationResultsUrl = (id: number,) => {




  return `/api/mobile/simulations/${id}/results`
}

export const getSimulationResults = async (id: number, options?: RequestInit): Promise<SimulationResults> => {

  return customFetch<SimulationResults>(getGetSimulationResultsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSimulationResultsQueryKey = (id: number,) => {
    return [
    `/api/mobile/simulations/${id}/results`
    ] as const;
    }


export const getGetSimulationResultsQueryOptions = <TData = Awaited<ReturnType<typeof getSimulationResults>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSimulationResults>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimulationResultsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimulationResults>>> = ({ signal }) => getSimulationResults(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSimulationResults>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSimulationResultsQueryResult = NonNullable<Awaited<ReturnType<typeof getSimulationResults>>>
export type GetSimulationResultsQueryError = ErrorType<unknown>



export function useGetSimulationResults<TData = Awaited<ReturnType<typeof getSimulationResults>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSimulationResults>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSimulationResultsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getSetSimulationRankingParticipationUrl = (id: number,) => {




  return `/api/mobile/simulations/${id}/ranking-participation`
}

export const setSimulationRankingParticipation = async (id: number,
    setSimulationRankingParticipationBody: SetSimulationRankingParticipationBody, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getSetSimulationRankingParticipationUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      setSimulationRankingParticipationBody,)
  }
);}




export const getSetSimulationRankingParticipationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSimulationRankingParticipation>>, TError,{id: number;data: BodyType<SetSimulationRankingParticipationBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setSimulationRankingParticipation>>, TError,{id: number;data: BodyType<SetSimulationRankingParticipationBody>}, TContext> => {

const mutationKey = ['setSimulationRankingParticipation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setSimulationRankingParticipation>>, {id: number;data: BodyType<SetSimulationRankingParticipationBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  setSimulationRankingParticipation(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetSimulationRankingParticipationMutationResult = NonNullable<Awaited<ReturnType<typeof setSimulationRankingParticipation>>>
    export type SetSimulationRankingParticipationMutationBody = BodyType<SetSimulationRankingParticipationBody>
    export type SetSimulationRankingParticipationMutationError = ErrorType<unknown>

    export const useSetSimulationRankingParticipation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSimulationRankingParticipation>>, TError,{id: number;data: BodyType<SetSimulationRankingParticipationBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setSimulationRankingParticipation>>,
        TError,
        {id: number;data: BodyType<SetSimulationRankingParticipationBody>},
        TContext
      > => {
      return useMutation(getSetSimulationRankingParticipationMutationOptions(options));
    }

export const getGetSimulationLeaderboardUrl = (id: number,) => {




  return `/api/mobile/simulations/${id}/leaderboard`
}

export const getSimulationLeaderboard = async (id: number, options?: RequestInit): Promise<SimulationLeaderboard> => {

  return customFetch<SimulationLeaderboard>(getGetSimulationLeaderboardUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSimulationLeaderboardQueryKey = (id: number,) => {
    return [
    `/api/mobile/simulations/${id}/leaderboard`
    ] as const;
    }


export const getGetSimulationLeaderboardQueryOptions = <TData = Awaited<ReturnType<typeof getSimulationLeaderboard>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSimulationLeaderboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimulationLeaderboardQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimulationLeaderboard>>> = ({ signal }) => getSimulationLeaderboard(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSimulationLeaderboard>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSimulationLeaderboardQueryResult = NonNullable<Awaited<ReturnType<typeof getSimulationLeaderboard>>>
export type GetSimulationLeaderboardQueryError = ErrorType<unknown>



export function useGetSimulationLeaderboard<TData = Awaited<ReturnType<typeof getSimulationLeaderboard>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSimulationLeaderboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSimulationLeaderboardQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateOfficialSimulationUrl = () => {




  return `/api/admin/simulations`
}

export const createOfficialSimulation = async (officialSimulationInput: OfficialSimulationInput, options?: RequestInit): Promise<Simulation> => {

  return customFetch<Simulation>(getCreateOfficialSimulationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      officialSimulationInput,)
  }
);}




export const getCreateOfficialSimulationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOfficialSimulation>>, TError,{data: BodyType<OfficialSimulationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOfficialSimulation>>, TError,{data: BodyType<OfficialSimulationInput>}, TContext> => {

const mutationKey = ['createOfficialSimulation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOfficialSimulation>>, {data: BodyType<OfficialSimulationInput>}> = (props) => {
          const {data} = props ?? {};

          return  createOfficialSimulation(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOfficialSimulationMutationResult = NonNullable<Awaited<ReturnType<typeof createOfficialSimulation>>>
    export type CreateOfficialSimulationMutationBody = BodyType<OfficialSimulationInput>
    export type CreateOfficialSimulationMutationError = ErrorType<unknown>

    export const useCreateOfficialSimulation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOfficialSimulation>>, TError,{data: BodyType<OfficialSimulationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createOfficialSimulation>>,
        TError,
        {data: BodyType<OfficialSimulationInput>},
        TContext
      > => {
      return useMutation(getCreateOfficialSimulationMutationOptions(options));
    }

export const getCreateSimulationExportUrl = () => {




  return `/api/mobile/exports/simulation`
}

export const createSimulationExport = async (simulationExportInput: SimulationExportInput, options?: RequestInit): Promise<ExportJob> => {

  return customFetch<ExportJob>(getCreateSimulationExportUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      simulationExportInput,)
  }
);}




export const getCreateSimulationExportMutationOptions = <TError = ErrorType<UnauthorizedResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSimulationExport>>, TError,{data: BodyType<SimulationExportInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSimulationExport>>, TError,{data: BodyType<SimulationExportInput>}, TContext> => {

const mutationKey = ['createSimulationExport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSimulationExport>>, {data: BodyType<SimulationExportInput>}> = (props) => {
          const {data} = props ?? {};

          return  createSimulationExport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSimulationExportMutationResult = NonNullable<Awaited<ReturnType<typeof createSimulationExport>>>
    export type CreateSimulationExportMutationBody = BodyType<SimulationExportInput>
    export type CreateSimulationExportMutationError = ErrorType<UnauthorizedResponse | void>

    export const useCreateSimulationExport = <TError = ErrorType<UnauthorizedResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSimulationExport>>, TError,{data: BodyType<SimulationExportInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSimulationExport>>,
        TError,
        {data: BodyType<SimulationExportInput>},
        TContext
      > => {
      return useMutation(getCreateSimulationExportMutationOptions(options));
    }

export const getCreateNotebookExportUrl = () => {




  return `/api/mobile/exports/notebook`
}

export const createNotebookExport = async (notebookExportInput: NotebookExportInput, options?: RequestInit): Promise<ExportJob> => {

  return customFetch<ExportJob>(getCreateNotebookExportUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      notebookExportInput,)
  }
);}




export const getCreateNotebookExportMutationOptions = <TError = ErrorType<UnauthorizedResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNotebookExport>>, TError,{data: BodyType<NotebookExportInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createNotebookExport>>, TError,{data: BodyType<NotebookExportInput>}, TContext> => {

const mutationKey = ['createNotebookExport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createNotebookExport>>, {data: BodyType<NotebookExportInput>}> = (props) => {
          const {data} = props ?? {};

          return  createNotebookExport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateNotebookExportMutationResult = NonNullable<Awaited<ReturnType<typeof createNotebookExport>>>
    export type CreateNotebookExportMutationBody = BodyType<NotebookExportInput>
    export type CreateNotebookExportMutationError = ErrorType<UnauthorizedResponse | void>

    export const useCreateNotebookExport = <TError = ErrorType<UnauthorizedResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNotebookExport>>, TError,{data: BodyType<NotebookExportInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createNotebookExport>>,
        TError,
        {data: BodyType<NotebookExportInput>},
        TContext
      > => {
      return useMutation(getCreateNotebookExportMutationOptions(options));
    }

export const getCreateQuestionsExportUrl = () => {




  return `/api/mobile/exports/questions`
}

export const createQuestionsExport = async (questionsExportInput: QuestionsExportInput, options?: RequestInit): Promise<ExportJob> => {

  return customFetch<ExportJob>(getCreateQuestionsExportUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      questionsExportInput,)
  }
);}




export const getCreateQuestionsExportMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createQuestionsExport>>, TError,{data: BodyType<QuestionsExportInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createQuestionsExport>>, TError,{data: BodyType<QuestionsExportInput>}, TContext> => {

const mutationKey = ['createQuestionsExport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createQuestionsExport>>, {data: BodyType<QuestionsExportInput>}> = (props) => {
          const {data} = props ?? {};

          return  createQuestionsExport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateQuestionsExportMutationResult = NonNullable<Awaited<ReturnType<typeof createQuestionsExport>>>
    export type CreateQuestionsExportMutationBody = BodyType<QuestionsExportInput>
    export type CreateQuestionsExportMutationError = ErrorType<void>

    export const useCreateQuestionsExport = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createQuestionsExport>>, TError,{data: BodyType<QuestionsExportInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createQuestionsExport>>,
        TError,
        {data: BodyType<QuestionsExportInput>},
        TContext
      > => {
      return useMutation(getCreateQuestionsExportMutationOptions(options));
    }

export const getCreateContentPdfUrl = () => {




  return `/api/mobile/exports/content/pdf`
}

export const createContentPdf = async (contentExportInput: ContentExportInput, options?: RequestInit): Promise<ContentPdfResult> => {

  return customFetch<ContentPdfResult>(getCreateContentPdfUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      contentExportInput,)
  }
);}




export const getCreateContentPdfMutationOptions = <TError = ErrorType<void | UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createContentPdf>>, TError,{data: BodyType<ContentExportInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createContentPdf>>, TError,{data: BodyType<ContentExportInput>}, TContext> => {

const mutationKey = ['createContentPdf'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createContentPdf>>, {data: BodyType<ContentExportInput>}> = (props) => {
          const {data} = props ?? {};

          return  createContentPdf(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateContentPdfMutationResult = NonNullable<Awaited<ReturnType<typeof createContentPdf>>>
    export type CreateContentPdfMutationBody = BodyType<ContentExportInput>
    export type CreateContentPdfMutationError = ErrorType<void | UnauthorizedResponse>

    export const useCreateContentPdf = <TError = ErrorType<void | UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createContentPdf>>, TError,{data: BodyType<ContentExportInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createContentPdf>>,
        TError,
        {data: BodyType<ContentExportInput>},
        TContext
      > => {
      return useMutation(getCreateContentPdfMutationOptions(options));
    }

export const getCreateStatisticsExportUrl = () => {




  return `/api/mobile/exports/statistics`
}

export const createStatisticsExport = async (statisticsExportInput: StatisticsExportInput, options?: RequestInit): Promise<ExportJob> => {

  return customFetch<ExportJob>(getCreateStatisticsExportUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      statisticsExportInput,)
  }
);}




export const getCreateStatisticsExportMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStatisticsExport>>, TError,{data: BodyType<StatisticsExportInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createStatisticsExport>>, TError,{data: BodyType<StatisticsExportInput>}, TContext> => {

const mutationKey = ['createStatisticsExport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createStatisticsExport>>, {data: BodyType<StatisticsExportInput>}> = (props) => {
          const {data} = props ?? {};

          return  createStatisticsExport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateStatisticsExportMutationResult = NonNullable<Awaited<ReturnType<typeof createStatisticsExport>>>
    export type CreateStatisticsExportMutationBody = BodyType<StatisticsExportInput>
    export type CreateStatisticsExportMutationError = ErrorType<unknown>

    export const useCreateStatisticsExport = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStatisticsExport>>, TError,{data: BodyType<StatisticsExportInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createStatisticsExport>>,
        TError,
        {data: BodyType<StatisticsExportInput>},
        TContext
      > => {
      return useMutation(getCreateStatisticsExportMutationOptions(options));
    }

export const getGetExportJobUrl = (id: string,) => {




  return `/api/mobile/exports/${id}`
}

export const getExportJob = async (id: string, options?: RequestInit): Promise<ExportJob> => {

  return customFetch<ExportJob>(getGetExportJobUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetExportJobQueryKey = (id: string,) => {
    return [
    `/api/mobile/exports/${id}`
    ] as const;
    }


export const getGetExportJobQueryOptions = <TData = Awaited<ReturnType<typeof getExportJob>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getExportJob>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExportJobQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExportJob>>> = ({ signal }) => getExportJob(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExportJob>>, TError, TData> & { queryKey: QueryKey }
}

export type GetExportJobQueryResult = NonNullable<Awaited<ReturnType<typeof getExportJob>>>
export type GetExportJobQueryError = ErrorType<void>



export function useGetExportJob<TData = Awaited<ReturnType<typeof getExportJob>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getExportJob>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetExportJobQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListPublicQuestionsUrl = (params?: ListPublicQuestionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/mobile/questions?${stringifiedParams}` : `/api/mobile/questions`
}

/**
 * Defaults to QUESTION_BANK. Filters and pagination are evaluated by the backend. The response never contains answer keys or pedagogical feedback.
 * @summary Secure cursor-paginated public question list
 */
export const listPublicQuestions = async (params?: ListPublicQuestionsParams, options?: RequestInit): Promise<QuestionListResponse> => {

  return customFetch<QuestionListResponse>(getListPublicQuestionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPublicQuestionsQueryKey = (params?: ListPublicQuestionsParams,) => {
    return [
    `/api/mobile/questions`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPublicQuestionsQueryOptions = <TData = Awaited<ReturnType<typeof listPublicQuestions>>, TError = ErrorType<ValidationErrorResponse>>(params?: ListPublicQuestionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPublicQuestions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPublicQuestionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPublicQuestions>>> = ({ signal }) => listPublicQuestions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPublicQuestions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPublicQuestionsQueryResult = NonNullable<Awaited<ReturnType<typeof listPublicQuestions>>>
export type ListPublicQuestionsQueryError = ErrorType<ValidationErrorResponse>


/**
 * @summary Secure cursor-paginated public question list
 */

export function useListPublicQuestions<TData = Awaited<ReturnType<typeof listPublicQuestions>>, TError = ErrorType<ValidationErrorResponse>>(
 params?: ListPublicQuestionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPublicQuestions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPublicQuestionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetPublicQuestionDetailsUrl = (id: number,) => {




  return `/api/mobile/questions/${id}`
}

/**
 * @summary Load a question for resolution without its answer or feedback
 */
export const getPublicQuestionDetails = async (id: number, options?: RequestInit): Promise<QuestionDetails> => {

  return customFetch<QuestionDetails>(getGetPublicQuestionDetailsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicQuestionDetailsQueryKey = (id: number,) => {
    return [
    `/api/mobile/questions/${id}`
    ] as const;
    }


export const getGetPublicQuestionDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getPublicQuestionDetails>>, TError = ErrorType<ValidationErrorResponse | PremiumRequiredResponse | ContentNotFoundResponse>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicQuestionDetails>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicQuestionDetailsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicQuestionDetails>>> = ({ signal }) => getPublicQuestionDetails(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicQuestionDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPublicQuestionDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicQuestionDetails>>>
export type GetPublicQuestionDetailsQueryError = ErrorType<ValidationErrorResponse | PremiumRequiredResponse | ContentNotFoundResponse>


/**
 * @summary Load a question for resolution without its answer or feedback
 */

export function useGetPublicQuestionDetails<TData = Awaited<ReturnType<typeof getPublicQuestionDetails>>, TError = ErrorType<ValidationErrorResponse | PremiumRequiredResponse | ContentNotFoundResponse>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicQuestionDetails>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPublicQuestionDetailsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetGuidedQuestionExplanationUrl = (id: number,) => {




  return `/api/mobile/questions/${id}/explanation`
}

/**
 * @summary Official explanation before answering in guided study only
 */
export const getGuidedQuestionExplanation = async (id: number, options?: RequestInit): Promise<QuestionAttemptFeedback> => {

  return customFetch<QuestionAttemptFeedback>(getGetGuidedQuestionExplanationUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetGuidedQuestionExplanationQueryKey = (id: number,) => {
    return [
    `/api/mobile/questions/${id}/explanation`
    ] as const;
    }


export const getGetGuidedQuestionExplanationQueryOptions = <TData = Awaited<ReturnType<typeof getGuidedQuestionExplanation>>, TError = ErrorType<void>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGuidedQuestionExplanation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGuidedQuestionExplanationQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGuidedQuestionExplanation>>> = ({ signal }) => getGuidedQuestionExplanation(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGuidedQuestionExplanation>>, TError, TData> & { queryKey: QueryKey }
}

export type GetGuidedQuestionExplanationQueryResult = NonNullable<Awaited<ReturnType<typeof getGuidedQuestionExplanation>>>
export type GetGuidedQuestionExplanationQueryError = ErrorType<void>


/**
 * @summary Official explanation before answering in guided study only
 */

export function useGetGuidedQuestionExplanation<TData = Awaited<ReturnType<typeof getGuidedQuestionExplanation>>, TError = ErrorType<void>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGuidedQuestionExplanation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetGuidedQuestionExplanationQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetQuestionPdfUrl = (id: number,) => {




  return `/api/mobile/questions/${id}/pdf`
}

/**
 * @summary Download one accessible question with its answer key in the footer
 */
export const getQuestionPdf = async (id: number, options?: RequestInit): Promise<GetQuestionPdf200> => {

  return customFetch<GetQuestionPdf200>(getGetQuestionPdfUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetQuestionPdfQueryKey = (id: number,) => {
    return [
    `/api/mobile/questions/${id}/pdf`
    ] as const;
    }


export const getGetQuestionPdfQueryOptions = <TData = Awaited<ReturnType<typeof getQuestionPdf>>, TError = ErrorType<void>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQuestionPdf>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuestionPdfQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuestionPdf>>> = ({ signal }) => getQuestionPdf(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQuestionPdf>>, TError, TData> & { queryKey: QueryKey }
}

export type GetQuestionPdfQueryResult = NonNullable<Awaited<ReturnType<typeof getQuestionPdf>>>
export type GetQuestionPdfQueryError = ErrorType<void>


/**
 * @summary Download one accessible question with its answer key in the footer
 */

export function useGetQuestionPdf<TData = Awaited<ReturnType<typeof getQuestionPdf>>, TError = ErrorType<void>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQuestionPdf>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetQuestionPdfQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListMobileFlashcardsUrl = (params?: ListMobileFlashcardsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/mobile/flashcards?${stringifiedParams}` : `/api/mobile/flashcards`
}

/**
 * @summary List accessible flashcards inherited from their content
 */
export const listMobileFlashcards = async (params?: ListMobileFlashcardsParams, options?: RequestInit): Promise<MobileFlashcardListAllowedResponse> => {

  return customFetch<MobileFlashcardListAllowedResponse>(getListMobileFlashcardsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMobileFlashcardsQueryKey = (params?: ListMobileFlashcardsParams,) => {
    return [
    `/api/mobile/flashcards`, ...(params ? [params] : [])
    ] as const;
    }


export const getListMobileFlashcardsQueryOptions = <TData = Awaited<ReturnType<typeof listMobileFlashcards>>, TError = ErrorType<UnauthorizedResponse | PremiumRequiredResponse | ContentNotFoundResponse>>(params?: ListMobileFlashcardsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMobileFlashcards>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMobileFlashcardsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMobileFlashcards>>> = ({ signal }) => listMobileFlashcards(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMobileFlashcards>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMobileFlashcardsQueryResult = NonNullable<Awaited<ReturnType<typeof listMobileFlashcards>>>
export type ListMobileFlashcardsQueryError = ErrorType<UnauthorizedResponse | PremiumRequiredResponse | ContentNotFoundResponse>


/**
 * @summary List accessible flashcards inherited from their content
 */

export function useListMobileFlashcards<TData = Awaited<ReturnType<typeof listMobileFlashcards>>, TError = ErrorType<UnauthorizedResponse | PremiumRequiredResponse | ContentNotFoundResponse>>(
 params?: ListMobileFlashcardsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMobileFlashcards>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMobileFlashcardsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListMobileVideosUrl = (params?: ListMobileVideosParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/mobile/videos?${stringifiedParams}` : `/api/mobile/videos`
}

/**
 * @summary List accessible videos inherited from their content
 */
export const listMobileVideos = async (params?: ListMobileVideosParams, options?: RequestInit): Promise<MobileVideoListAllowedResponse> => {

  return customFetch<MobileVideoListAllowedResponse>(getListMobileVideosUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMobileVideosQueryKey = (params?: ListMobileVideosParams,) => {
    return [
    `/api/mobile/videos`, ...(params ? [params] : [])
    ] as const;
    }


export const getListMobileVideosQueryOptions = <TData = Awaited<ReturnType<typeof listMobileVideos>>, TError = ErrorType<UnauthorizedResponse | PremiumRequiredResponse | ContentNotFoundResponse>>(params?: ListMobileVideosParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMobileVideos>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMobileVideosQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMobileVideos>>> = ({ signal }) => listMobileVideos(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMobileVideos>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMobileVideosQueryResult = NonNullable<Awaited<ReturnType<typeof listMobileVideos>>>
export type ListMobileVideosQueryError = ErrorType<UnauthorizedResponse | PremiumRequiredResponse | ContentNotFoundResponse>


/**
 * @summary List accessible videos inherited from their content
 */

export function useListMobileVideos<TData = Awaited<ReturnType<typeof listMobileVideos>>, TError = ErrorType<UnauthorizedResponse | PremiumRequiredResponse | ContentNotFoundResponse>>(
 params?: ListMobileVideosParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMobileVideos>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMobileVideosQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getAdminLoginUrl = () => {




  return `/api/admin/auth/login`
}

/**
 * @summary Admin login
 */
export const adminLogin = async (adminLoginInput: AdminLoginInput, options?: RequestInit): Promise<AdminAuthResponse> => {

  return customFetch<AdminAuthResponse>(getAdminLoginUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      adminLoginInput,)
  }
);}




export const getAdminLoginMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminLogin>>, TError,{data: BodyType<AdminLoginInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminLogin>>, TError,{data: BodyType<AdminLoginInput>}, TContext> => {

const mutationKey = ['adminLogin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminLogin>>, {data: BodyType<AdminLoginInput>}> = (props) => {
          const {data} = props ?? {};

          return  adminLogin(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminLoginMutationResult = NonNullable<Awaited<ReturnType<typeof adminLogin>>>
    export type AdminLoginMutationBody = BodyType<AdminLoginInput>
    export type AdminLoginMutationError = ErrorType<void>

    /**
 * @summary Admin login
 */
export const useAdminLogin = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminLogin>>, TError,{data: BodyType<AdminLoginInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof adminLogin>>,
        TError,
        {data: BodyType<AdminLoginInput>},
        TContext
      > => {
      return useMutation(getAdminLoginMutationOptions(options));
    }

export const getAdminGetMeUrl = () => {




  return `/api/admin/auth/me`
}

/**
 * @summary Get current admin
 */
export const adminGetMe = async ( options?: RequestInit): Promise<AdminUser> => {

  return customFetch<AdminUser>(getAdminGetMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminGetMeQueryKey = () => {
    return [
    `/api/admin/auth/me`
    ] as const;
    }


export const getAdminGetMeQueryOptions = <TData = Awaited<ReturnType<typeof adminGetMe>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminGetMe>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminGetMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetMe>>> = ({ signal }) => adminGetMe({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGetMe>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminGetMeQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetMe>>>
export type AdminGetMeQueryError = ErrorType<unknown>


/**
 * @summary Get current admin
 */

export function useAdminGetMe<TData = Awaited<ReturnType<typeof adminGetMe>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminGetMe>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminGetMeQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetAdminStatsUrl = () => {




  return `/api/admin/stats`
}

/**
 * @summary Get dashboard stats
 */
export const getAdminStats = async ( options?: RequestInit): Promise<AdminStats> => {

  return customFetch<AdminStats>(getGetAdminStatsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminStatsQueryKey = () => {
    return [
    `/api/admin/stats`
    ] as const;
    }


export const getGetAdminStatsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminStats>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminStatsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminStats>>> = ({ signal }) => getAdminStats({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminStats>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminStats>>>
export type GetAdminStatsQueryError = ErrorType<unknown>


/**
 * @summary Get dashboard stats
 */

export function useGetAdminStats<TData = Awaited<ReturnType<typeof getAdminStats>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminStatsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListBancasUrl = () => {




  return `/api/admin/bancas`
}

/**
 * @summary List all bancas
 */
export const listBancas = async ( options?: RequestInit): Promise<Banca[]> => {

  return customFetch<Banca[]>(getListBancasUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListBancasQueryKey = () => {
    return [
    `/api/admin/bancas`
    ] as const;
    }


export const getListBancasQueryOptions = <TData = Awaited<ReturnType<typeof listBancas>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBancas>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBancasQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBancas>>> = ({ signal }) => listBancas({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBancas>>, TError, TData> & { queryKey: QueryKey }
}

export type ListBancasQueryResult = NonNullable<Awaited<ReturnType<typeof listBancas>>>
export type ListBancasQueryError = ErrorType<unknown>


/**
 * @summary List all bancas
 */

export function useListBancas<TData = Awaited<ReturnType<typeof listBancas>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBancas>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListBancasQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateBancaUrl = () => {




  return `/api/admin/bancas`
}

/**
 * @summary Create banca
 */
export const createBanca = async (bancaInput: BancaInput, options?: RequestInit): Promise<Banca> => {

  return customFetch<Banca>(getCreateBancaUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bancaInput,)
  }
);}




export const getCreateBancaMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBanca>>, TError,{data: BodyType<BancaInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createBanca>>, TError,{data: BodyType<BancaInput>}, TContext> => {

const mutationKey = ['createBanca'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBanca>>, {data: BodyType<BancaInput>}> = (props) => {
          const {data} = props ?? {};

          return  createBanca(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBancaMutationResult = NonNullable<Awaited<ReturnType<typeof createBanca>>>
    export type CreateBancaMutationBody = BodyType<BancaInput>
    export type CreateBancaMutationError = ErrorType<unknown>

    /**
 * @summary Create banca
 */
export const useCreateBanca = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBanca>>, TError,{data: BodyType<BancaInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createBanca>>,
        TError,
        {data: BodyType<BancaInput>},
        TContext
      > => {
      return useMutation(getCreateBancaMutationOptions(options));
    }

export const getUpdateBancaUrl = (id: number,) => {




  return `/api/admin/bancas/${id}`
}

/**
 * @summary Update banca
 */
export const updateBanca = async (id: number,
    bancaUpdate: BancaUpdate, options?: RequestInit): Promise<Banca> => {

  return customFetch<Banca>(getUpdateBancaUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bancaUpdate,)
  }
);}




export const getUpdateBancaMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBanca>>, TError,{id: number;data: BodyType<BancaUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateBanca>>, TError,{id: number;data: BodyType<BancaUpdate>}, TContext> => {

const mutationKey = ['updateBanca'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateBanca>>, {id: number;data: BodyType<BancaUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateBanca(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateBancaMutationResult = NonNullable<Awaited<ReturnType<typeof updateBanca>>>
    export type UpdateBancaMutationBody = BodyType<BancaUpdate>
    export type UpdateBancaMutationError = ErrorType<unknown>

    /**
 * @summary Update banca
 */
export const useUpdateBanca = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBanca>>, TError,{id: number;data: BodyType<BancaUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateBanca>>,
        TError,
        {id: number;data: BodyType<BancaUpdate>},
        TContext
      > => {
      return useMutation(getUpdateBancaMutationOptions(options));
    }

export const getDeleteBancaUrl = (id: number,) => {




  return `/api/admin/bancas/${id}`
}

/**
 * @summary Delete banca
 */
export const deleteBanca = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteBancaUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteBancaMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBanca>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteBanca>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteBanca'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBanca>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteBanca(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteBancaMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBanca>>>

    export type DeleteBancaMutationError = ErrorType<unknown>

    /**
 * @summary Delete banca
 */
export const useDeleteBanca = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBanca>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteBanca>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteBancaMutationOptions(options));
    }

export const getListDisciplinasUrl = () => {




  return `/api/admin/disciplinas`
}

/**
 * @summary List all disciplinas
 */
export const listDisciplinas = async ( options?: RequestInit): Promise<Disciplina[]> => {

  return customFetch<Disciplina[]>(getListDisciplinasUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDisciplinasQueryKey = () => {
    return [
    `/api/admin/disciplinas`
    ] as const;
    }


export const getListDisciplinasQueryOptions = <TData = Awaited<ReturnType<typeof listDisciplinas>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDisciplinas>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDisciplinasQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDisciplinas>>> = ({ signal }) => listDisciplinas({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDisciplinas>>, TError, TData> & { queryKey: QueryKey }
}

export type ListDisciplinasQueryResult = NonNullable<Awaited<ReturnType<typeof listDisciplinas>>>
export type ListDisciplinasQueryError = ErrorType<unknown>


/**
 * @summary List all disciplinas
 */

export function useListDisciplinas<TData = Awaited<ReturnType<typeof listDisciplinas>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDisciplinas>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListDisciplinasQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateDisciplinaUrl = () => {




  return `/api/admin/disciplinas`
}

/**
 * @summary Create disciplina
 */
export const createDisciplina = async (disciplinaInput: DisciplinaInput, options?: RequestInit): Promise<Disciplina> => {

  return customFetch<Disciplina>(getCreateDisciplinaUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      disciplinaInput,)
  }
);}




export const getCreateDisciplinaMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDisciplina>>, TError,{data: BodyType<DisciplinaInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createDisciplina>>, TError,{data: BodyType<DisciplinaInput>}, TContext> => {

const mutationKey = ['createDisciplina'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDisciplina>>, {data: BodyType<DisciplinaInput>}> = (props) => {
          const {data} = props ?? {};

          return  createDisciplina(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDisciplinaMutationResult = NonNullable<Awaited<ReturnType<typeof createDisciplina>>>
    export type CreateDisciplinaMutationBody = BodyType<DisciplinaInput>
    export type CreateDisciplinaMutationError = ErrorType<unknown>

    /**
 * @summary Create disciplina
 */
export const useCreateDisciplina = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDisciplina>>, TError,{data: BodyType<DisciplinaInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createDisciplina>>,
        TError,
        {data: BodyType<DisciplinaInput>},
        TContext
      > => {
      return useMutation(getCreateDisciplinaMutationOptions(options));
    }

export const getUpdateDisciplinaUrl = (id: string,) => {




  return `/api/admin/disciplinas/${id}`
}

/**
 * @summary Update disciplina
 */
export const updateDisciplina = async (id: string,
    disciplinaUpdate: DisciplinaUpdate, options?: RequestInit): Promise<Disciplina> => {

  return customFetch<Disciplina>(getUpdateDisciplinaUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      disciplinaUpdate,)
  }
);}




export const getUpdateDisciplinaMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDisciplina>>, TError,{id: string;data: BodyType<DisciplinaUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDisciplina>>, TError,{id: string;data: BodyType<DisciplinaUpdate>}, TContext> => {

const mutationKey = ['updateDisciplina'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDisciplina>>, {id: string;data: BodyType<DisciplinaUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateDisciplina(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDisciplinaMutationResult = NonNullable<Awaited<ReturnType<typeof updateDisciplina>>>
    export type UpdateDisciplinaMutationBody = BodyType<DisciplinaUpdate>
    export type UpdateDisciplinaMutationError = ErrorType<unknown>

    /**
 * @summary Update disciplina
 */
export const useUpdateDisciplina = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDisciplina>>, TError,{id: string;data: BodyType<DisciplinaUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateDisciplina>>,
        TError,
        {id: string;data: BodyType<DisciplinaUpdate>},
        TContext
      > => {
      return useMutation(getUpdateDisciplinaMutationOptions(options));
    }

export const getDeleteDisciplinaUrl = (id: string,) => {




  return `/api/admin/disciplinas/${id}`
}

/**
 * @summary Delete disciplina
 */
export const deleteDisciplina = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteDisciplinaUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteDisciplinaMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDisciplina>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDisciplina>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteDisciplina'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDisciplina>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteDisciplina(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteDisciplinaMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDisciplina>>>

    export type DeleteDisciplinaMutationError = ErrorType<unknown>

    /**
 * @summary Delete disciplina
 */
export const useDeleteDisciplina = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDisciplina>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteDisciplina>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteDisciplinaMutationOptions(options));
    }

export const getListUnidadesUrl = (params?: ListUnidadesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/unidades?${stringifiedParams}` : `/api/admin/unidades`
}

/**
 * @summary List unidades
 */
export const listUnidades = async (params?: ListUnidadesParams, options?: RequestInit): Promise<Unidade[]> => {

  return customFetch<Unidade[]>(getListUnidadesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListUnidadesQueryKey = (params?: ListUnidadesParams,) => {
    return [
    `/api/admin/unidades`, ...(params ? [params] : [])
    ] as const;
    }


export const getListUnidadesQueryOptions = <TData = Awaited<ReturnType<typeof listUnidades>>, TError = ErrorType<unknown>>(params?: ListUnidadesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listUnidades>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUnidadesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUnidades>>> = ({ signal }) => listUnidades(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUnidades>>, TError, TData> & { queryKey: QueryKey }
}

export type ListUnidadesQueryResult = NonNullable<Awaited<ReturnType<typeof listUnidades>>>
export type ListUnidadesQueryError = ErrorType<unknown>


/**
 * @summary List unidades
 */

export function useListUnidades<TData = Awaited<ReturnType<typeof listUnidades>>, TError = ErrorType<unknown>>(
 params?: ListUnidadesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listUnidades>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListUnidadesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateUnidadeUrl = () => {




  return `/api/admin/unidades`
}

/**
 * @summary Create unidade
 */
export const createUnidade = async (unidadeInput: UnidadeInput, options?: RequestInit): Promise<Unidade> => {

  return customFetch<Unidade>(getCreateUnidadeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      unidadeInput,)
  }
);}




export const getCreateUnidadeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUnidade>>, TError,{data: BodyType<UnidadeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createUnidade>>, TError,{data: BodyType<UnidadeInput>}, TContext> => {

const mutationKey = ['createUnidade'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUnidade>>, {data: BodyType<UnidadeInput>}> = (props) => {
          const {data} = props ?? {};

          return  createUnidade(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateUnidadeMutationResult = NonNullable<Awaited<ReturnType<typeof createUnidade>>>
    export type CreateUnidadeMutationBody = BodyType<UnidadeInput>
    export type CreateUnidadeMutationError = ErrorType<unknown>

    /**
 * @summary Create unidade
 */
export const useCreateUnidade = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUnidade>>, TError,{data: BodyType<UnidadeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createUnidade>>,
        TError,
        {data: BodyType<UnidadeInput>},
        TContext
      > => {
      return useMutation(getCreateUnidadeMutationOptions(options));
    }

export const getUpdateUnidadeUrl = (id: string,) => {




  return `/api/admin/unidades/${id}`
}

/**
 * @summary Update unidade
 */
export const updateUnidade = async (id: string,
    unidadeUpdate: UnidadeUpdate, options?: RequestInit): Promise<Unidade> => {

  return customFetch<Unidade>(getUpdateUnidadeUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      unidadeUpdate,)
  }
);}




export const getUpdateUnidadeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUnidade>>, TError,{id: string;data: BodyType<UnidadeUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateUnidade>>, TError,{id: string;data: BodyType<UnidadeUpdate>}, TContext> => {

const mutationKey = ['updateUnidade'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUnidade>>, {id: string;data: BodyType<UnidadeUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateUnidade(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateUnidadeMutationResult = NonNullable<Awaited<ReturnType<typeof updateUnidade>>>
    export type UpdateUnidadeMutationBody = BodyType<UnidadeUpdate>
    export type UpdateUnidadeMutationError = ErrorType<unknown>

    /**
 * @summary Update unidade
 */
export const useUpdateUnidade = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUnidade>>, TError,{id: string;data: BodyType<UnidadeUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateUnidade>>,
        TError,
        {id: string;data: BodyType<UnidadeUpdate>},
        TContext
      > => {
      return useMutation(getUpdateUnidadeMutationOptions(options));
    }

export const getDeleteUnidadeUrl = (id: string,) => {




  return `/api/admin/unidades/${id}`
}

/**
 * @summary Delete unidade
 */
export const deleteUnidade = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteUnidadeUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteUnidadeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUnidade>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUnidade>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteUnidade'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUnidade>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteUnidade(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteUnidadeMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUnidade>>>

    export type DeleteUnidadeMutationError = ErrorType<unknown>

    /**
 * @summary Delete unidade
 */
export const useDeleteUnidade = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUnidade>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteUnidade>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteUnidadeMutationOptions(options));
    }

export const getListConteudosUrl = (params?: ListConteudosParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/conteudos?${stringifiedParams}` : `/api/admin/conteudos`
}

/**
 * @summary List conteúdos
 */
export const listConteudos = async (params?: ListConteudosParams, options?: RequestInit): Promise<Conteudo[]> => {

  return customFetch<Conteudo[]>(getListConteudosUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListConteudosQueryKey = (params?: ListConteudosParams,) => {
    return [
    `/api/admin/conteudos`, ...(params ? [params] : [])
    ] as const;
    }


export const getListConteudosQueryOptions = <TData = Awaited<ReturnType<typeof listConteudos>>, TError = ErrorType<unknown>>(params?: ListConteudosParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listConteudos>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListConteudosQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listConteudos>>> = ({ signal }) => listConteudos(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listConteudos>>, TError, TData> & { queryKey: QueryKey }
}

export type ListConteudosQueryResult = NonNullable<Awaited<ReturnType<typeof listConteudos>>>
export type ListConteudosQueryError = ErrorType<unknown>


/**
 * @summary List conteúdos
 */

export function useListConteudos<TData = Awaited<ReturnType<typeof listConteudos>>, TError = ErrorType<unknown>>(
 params?: ListConteudosParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listConteudos>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListConteudosQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateConteudoUrl = () => {




  return `/api/admin/conteudos`
}

/**
 * @summary Create conteúdo
 */
export const createConteudo = async (conteudoInput: ConteudoInput, options?: RequestInit): Promise<Conteudo> => {

  return customFetch<Conteudo>(getCreateConteudoUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      conteudoInput,)
  }
);}




export const getCreateConteudoMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createConteudo>>, TError,{data: BodyType<ConteudoInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createConteudo>>, TError,{data: BodyType<ConteudoInput>}, TContext> => {

const mutationKey = ['createConteudo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createConteudo>>, {data: BodyType<ConteudoInput>}> = (props) => {
          const {data} = props ?? {};

          return  createConteudo(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateConteudoMutationResult = NonNullable<Awaited<ReturnType<typeof createConteudo>>>
    export type CreateConteudoMutationBody = BodyType<ConteudoInput>
    export type CreateConteudoMutationError = ErrorType<unknown>

    /**
 * @summary Create conteúdo
 */
export const useCreateConteudo = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createConteudo>>, TError,{data: BodyType<ConteudoInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createConteudo>>,
        TError,
        {data: BodyType<ConteudoInput>},
        TContext
      > => {
      return useMutation(getCreateConteudoMutationOptions(options));
    }

export const getGetConteudoUrl = (id: string,) => {




  return `/api/admin/conteudos/${id}`
}

/**
 * @summary Get single conteúdo
 */
export const getConteudo = async (id: string, options?: RequestInit): Promise<Conteudo> => {

  return customFetch<Conteudo>(getGetConteudoUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetConteudoQueryKey = (id: string,) => {
    return [
    `/api/admin/conteudos/${id}`
    ] as const;
    }


export const getGetConteudoQueryOptions = <TData = Awaited<ReturnType<typeof getConteudo>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConteudo>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConteudoQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConteudo>>> = ({ signal }) => getConteudo(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConteudo>>, TError, TData> & { queryKey: QueryKey }
}

export type GetConteudoQueryResult = NonNullable<Awaited<ReturnType<typeof getConteudo>>>
export type GetConteudoQueryError = ErrorType<unknown>


/**
 * @summary Get single conteúdo
 */

export function useGetConteudo<TData = Awaited<ReturnType<typeof getConteudo>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConteudo>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetConteudoQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateConteudoUrl = (id: string,) => {




  return `/api/admin/conteudos/${id}`
}

/**
 * @summary Update conteúdo
 */
export const updateConteudo = async (id: string,
    conteudoUpdate: ConteudoUpdate, options?: RequestInit): Promise<Conteudo> => {

  return customFetch<Conteudo>(getUpdateConteudoUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      conteudoUpdate,)
  }
);}




export const getUpdateConteudoMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateConteudo>>, TError,{id: string;data: BodyType<ConteudoUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateConteudo>>, TError,{id: string;data: BodyType<ConteudoUpdate>}, TContext> => {

const mutationKey = ['updateConteudo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateConteudo>>, {id: string;data: BodyType<ConteudoUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateConteudo(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateConteudoMutationResult = NonNullable<Awaited<ReturnType<typeof updateConteudo>>>
    export type UpdateConteudoMutationBody = BodyType<ConteudoUpdate>
    export type UpdateConteudoMutationError = ErrorType<unknown>

    /**
 * @summary Update conteúdo
 */
export const useUpdateConteudo = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateConteudo>>, TError,{id: string;data: BodyType<ConteudoUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateConteudo>>,
        TError,
        {id: string;data: BodyType<ConteudoUpdate>},
        TContext
      > => {
      return useMutation(getUpdateConteudoMutationOptions(options));
    }

export const getDeleteConteudoUrl = (id: string,) => {




  return `/api/admin/conteudos/${id}`
}

/**
 * @summary Delete conteúdo
 */
export const deleteConteudo = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteConteudoUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteConteudoMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteConteudo>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteConteudo>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteConteudo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteConteudo>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteConteudo(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteConteudoMutationResult = NonNullable<Awaited<ReturnType<typeof deleteConteudo>>>

    export type DeleteConteudoMutationError = ErrorType<unknown>

    /**
 * @summary Delete conteúdo
 */
export const useDeleteConteudo = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteConteudo>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteConteudo>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteConteudoMutationOptions(options));
    }

export const getGetConteudoBlocosUrl = (id: string,
    modulo: string,) => {




  return `/api/admin/conteudos/${id}/blocos/${modulo}`
}

/**
 * @summary Get block content for a module
 */
export const getConteudoBlocos = async (id: string,
    modulo: string, options?: RequestInit): Promise<BlocosResponse> => {

  return customFetch<BlocosResponse>(getGetConteudoBlocosUrl(id,modulo),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetConteudoBlocosQueryKey = (id: string,
    modulo: string,) => {
    return [
    `/api/admin/conteudos/${id}/blocos/${modulo}`
    ] as const;
    }


export const getGetConteudoBlocosQueryOptions = <TData = Awaited<ReturnType<typeof getConteudoBlocos>>, TError = ErrorType<unknown>>(id: string,
    modulo: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConteudoBlocos>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConteudoBlocosQueryKey(id,modulo);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConteudoBlocos>>> = ({ signal }) => getConteudoBlocos(id,modulo, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id && modulo), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConteudoBlocos>>, TError, TData> & { queryKey: QueryKey }
}

export type GetConteudoBlocosQueryResult = NonNullable<Awaited<ReturnType<typeof getConteudoBlocos>>>
export type GetConteudoBlocosQueryError = ErrorType<unknown>


/**
 * @summary Get block content for a module
 */

export function useGetConteudoBlocos<TData = Awaited<ReturnType<typeof getConteudoBlocos>>, TError = ErrorType<unknown>>(
 id: string,
    modulo: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConteudoBlocos>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetConteudoBlocosQueryOptions(id,modulo,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateConteudoBlocosUrl = (id: string,
    modulo: string,) => {




  return `/api/admin/conteudos/${id}/blocos/${modulo}`
}

/**
 * @summary Update block content for a module
 */
export const updateConteudoBlocos = async (id: string,
    modulo: string,
    blocosInput: BlocosInput, options?: RequestInit): Promise<BlocosResponse> => {

  return customFetch<BlocosResponse>(getUpdateConteudoBlocosUrl(id,modulo),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      blocosInput,)
  }
);}




export const getUpdateConteudoBlocosMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateConteudoBlocos>>, TError,{id: string;modulo: string;data: BodyType<BlocosInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateConteudoBlocos>>, TError,{id: string;modulo: string;data: BodyType<BlocosInput>}, TContext> => {

const mutationKey = ['updateConteudoBlocos'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateConteudoBlocos>>, {id: string;modulo: string;data: BodyType<BlocosInput>}> = (props) => {
          const {id,modulo,data} = props ?? {};

          return  updateConteudoBlocos(id,modulo,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateConteudoBlocosMutationResult = NonNullable<Awaited<ReturnType<typeof updateConteudoBlocos>>>
    export type UpdateConteudoBlocosMutationBody = BodyType<BlocosInput>
    export type UpdateConteudoBlocosMutationError = ErrorType<unknown>

    /**
 * @summary Update block content for a module
 */
export const useUpdateConteudoBlocos = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateConteudoBlocos>>, TError,{id: string;modulo: string;data: BodyType<BlocosInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateConteudoBlocos>>,
        TError,
        {id: string;modulo: string;data: BodyType<BlocosInput>},
        TContext
      > => {
      return useMutation(getUpdateConteudoBlocosMutationOptions(options));
    }

export const getListQuestoesUrl = (params?: ListQuestoesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/questoes?${stringifiedParams}` : `/api/admin/questoes`
}

/**
 * @summary List questões
 */
export const listQuestoes = async (params?: ListQuestoesParams, options?: RequestInit): Promise<Questao[]> => {

  return customFetch<Questao[]>(getListQuestoesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListQuestoesQueryKey = (params?: ListQuestoesParams,) => {
    return [
    `/api/admin/questoes`, ...(params ? [params] : [])
    ] as const;
    }


export const getListQuestoesQueryOptions = <TData = Awaited<ReturnType<typeof listQuestoes>>, TError = ErrorType<unknown>>(params?: ListQuestoesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listQuestoes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQuestoesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuestoes>>> = ({ signal }) => listQuestoes(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listQuestoes>>, TError, TData> & { queryKey: QueryKey }
}

export type ListQuestoesQueryResult = NonNullable<Awaited<ReturnType<typeof listQuestoes>>>
export type ListQuestoesQueryError = ErrorType<unknown>


/**
 * @summary List questões
 */

export function useListQuestoes<TData = Awaited<ReturnType<typeof listQuestoes>>, TError = ErrorType<unknown>>(
 params?: ListQuestoesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listQuestoes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListQuestoesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateQuestaoUrl = () => {




  return `/api/admin/questoes`
}

/**
 * @summary Create questão
 */
export const createQuestao = async (questaoInput: QuestaoInput, options?: RequestInit): Promise<Questao> => {

  return customFetch<Questao>(getCreateQuestaoUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      questaoInput,)
  }
);}




export const getCreateQuestaoMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createQuestao>>, TError,{data: BodyType<QuestaoInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createQuestao>>, TError,{data: BodyType<QuestaoInput>}, TContext> => {

const mutationKey = ['createQuestao'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createQuestao>>, {data: BodyType<QuestaoInput>}> = (props) => {
          const {data} = props ?? {};

          return  createQuestao(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateQuestaoMutationResult = NonNullable<Awaited<ReturnType<typeof createQuestao>>>
    export type CreateQuestaoMutationBody = BodyType<QuestaoInput>
    export type CreateQuestaoMutationError = ErrorType<unknown>

    /**
 * @summary Create questão
 */
export const useCreateQuestao = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createQuestao>>, TError,{data: BodyType<QuestaoInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createQuestao>>,
        TError,
        {data: BodyType<QuestaoInput>},
        TContext
      > => {
      return useMutation(getCreateQuestaoMutationOptions(options));
    }

export const getUpdateQuestaoUrl = (id: number,) => {




  return `/api/admin/questoes/${id}`
}

/**
 * @summary Update questão
 */
export const updateQuestao = async (id: number,
    questaoUpdate: QuestaoUpdate, options?: RequestInit): Promise<Questao> => {

  return customFetch<Questao>(getUpdateQuestaoUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      questaoUpdate,)
  }
);}




export const getUpdateQuestaoMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateQuestao>>, TError,{id: number;data: BodyType<QuestaoUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateQuestao>>, TError,{id: number;data: BodyType<QuestaoUpdate>}, TContext> => {

const mutationKey = ['updateQuestao'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateQuestao>>, {id: number;data: BodyType<QuestaoUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateQuestao(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateQuestaoMutationResult = NonNullable<Awaited<ReturnType<typeof updateQuestao>>>
    export type UpdateQuestaoMutationBody = BodyType<QuestaoUpdate>
    export type UpdateQuestaoMutationError = ErrorType<unknown>

    /**
 * @summary Update questão
 */
export const useUpdateQuestao = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateQuestao>>, TError,{id: number;data: BodyType<QuestaoUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateQuestao>>,
        TError,
        {id: number;data: BodyType<QuestaoUpdate>},
        TContext
      > => {
      return useMutation(getUpdateQuestaoMutationOptions(options));
    }

export const getDeleteQuestaoUrl = (id: number,) => {




  return `/api/admin/questoes/${id}`
}

/**
 * @summary Delete questão
 */
export const deleteQuestao = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteQuestaoUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteQuestaoMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteQuestao>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteQuestao>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteQuestao'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteQuestao>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteQuestao(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteQuestaoMutationResult = NonNullable<Awaited<ReturnType<typeof deleteQuestao>>>

    export type DeleteQuestaoMutationError = ErrorType<unknown>

    /**
 * @summary Delete questão
 */
export const useDeleteQuestao = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteQuestao>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteQuestao>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteQuestaoMutationOptions(options));
    }

export const getListFlashcardsUrl = (params?: ListFlashcardsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/flashcards?${stringifiedParams}` : `/api/admin/flashcards`
}

/**
 * @summary List flashcards
 */
export const listFlashcards = async (params?: ListFlashcardsParams, options?: RequestInit): Promise<AdminFfCardPage> => {

  return customFetch<AdminFfCardPage>(getListFlashcardsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListFlashcardsQueryKey = (params?: ListFlashcardsParams,) => {
    return [
    `/api/admin/flashcards`, ...(params ? [params] : [])
    ] as const;
    }


export const getListFlashcardsQueryOptions = <TData = Awaited<ReturnType<typeof listFlashcards>>, TError = ErrorType<unknown>>(params?: ListFlashcardsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listFlashcards>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListFlashcardsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFlashcards>>> = ({ signal }) => listFlashcards(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listFlashcards>>, TError, TData> & { queryKey: QueryKey }
}

export type ListFlashcardsQueryResult = NonNullable<Awaited<ReturnType<typeof listFlashcards>>>
export type ListFlashcardsQueryError = ErrorType<unknown>


/**
 * @summary List flashcards
 */

export function useListFlashcards<TData = Awaited<ReturnType<typeof listFlashcards>>, TError = ErrorType<unknown>>(
 params?: ListFlashcardsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listFlashcards>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListFlashcardsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateFlashcardUrl = () => {




  return `/api/admin/flashcards`
}

/**
 * @summary Create flashcard
 */
export const createFlashcard = async (adminFfCardDraft: AdminFfCardDraft, options?: RequestInit): Promise<AdminFfCardWorkspace> => {

  return customFetch<AdminFfCardWorkspace>(getCreateFlashcardUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      adminFfCardDraft,)
  }
);}




export const getCreateFlashcardMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFlashcard>>, TError,{data: BodyType<AdminFfCardDraft>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createFlashcard>>, TError,{data: BodyType<AdminFfCardDraft>}, TContext> => {

const mutationKey = ['createFlashcard'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFlashcard>>, {data: BodyType<AdminFfCardDraft>}> = (props) => {
          const {data} = props ?? {};

          return  createFlashcard(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFlashcardMutationResult = NonNullable<Awaited<ReturnType<typeof createFlashcard>>>
    export type CreateFlashcardMutationBody = BodyType<AdminFfCardDraft>
    export type CreateFlashcardMutationError = ErrorType<unknown>

    /**
 * @summary Create flashcard
 */
export const useCreateFlashcard = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFlashcard>>, TError,{data: BodyType<AdminFfCardDraft>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createFlashcard>>,
        TError,
        {data: BodyType<AdminFfCardDraft>},
        TContext
      > => {
      return useMutation(getCreateFlashcardMutationOptions(options));
    }

export const getGetAdminFfCardUrl = (id: number,) => {




  return `/api/admin/flashcards/${id}`
}

export const getAdminFfCard = async (id: number, options?: RequestInit): Promise<AdminFfCardWorkspace> => {

  return customFetch<AdminFfCardWorkspace>(getGetAdminFfCardUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminFfCardQueryKey = (id: number,) => {
    return [
    `/api/admin/flashcards/${id}`
    ] as const;
    }


export const getGetAdminFfCardQueryOptions = <TData = Awaited<ReturnType<typeof getAdminFfCard>>, TError = ErrorType<FfCardsErrorResponse>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminFfCard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminFfCardQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminFfCard>>> = ({ signal }) => getAdminFfCard(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminFfCard>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminFfCardQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminFfCard>>>
export type GetAdminFfCardQueryError = ErrorType<FfCardsErrorResponse>



export function useGetAdminFfCard<TData = Awaited<ReturnType<typeof getAdminFfCard>>, TError = ErrorType<FfCardsErrorResponse>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminFfCard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminFfCardQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getDeleteFlashcardUrl = (id: number,) => {




  return `/api/admin/flashcards/${id}`
}

/**
 * @summary Delete flashcard
 */
export const deleteFlashcard = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteFlashcardUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteFlashcardMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFlashcard>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteFlashcard>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteFlashcard'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteFlashcard>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteFlashcard(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteFlashcardMutationResult = NonNullable<Awaited<ReturnType<typeof deleteFlashcard>>>

    export type DeleteFlashcardMutationError = ErrorType<unknown>

    /**
 * @summary Delete flashcard
 */
export const useDeleteFlashcard = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFlashcard>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteFlashcard>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteFlashcardMutationOptions(options));
    }

export const getSaveAdminFfCardDraftUrl = (id: number,) => {




  return `/api/admin/flashcards/${id}/draft`
}

export const saveAdminFfCardDraft = async (id: number,
    adminFfCardDraftUpdate: AdminFfCardDraftUpdate, options?: RequestInit): Promise<AdminFfCardWorkspace> => {

  return customFetch<AdminFfCardWorkspace>(getSaveAdminFfCardDraftUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      adminFfCardDraftUpdate,)
  }
);}




export const getSaveAdminFfCardDraftMutationOptions = <TError = ErrorType<FfCardsErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveAdminFfCardDraft>>, TError,{id: number;data: BodyType<AdminFfCardDraftUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveAdminFfCardDraft>>, TError,{id: number;data: BodyType<AdminFfCardDraftUpdate>}, TContext> => {

const mutationKey = ['saveAdminFfCardDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveAdminFfCardDraft>>, {id: number;data: BodyType<AdminFfCardDraftUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  saveAdminFfCardDraft(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveAdminFfCardDraftMutationResult = NonNullable<Awaited<ReturnType<typeof saveAdminFfCardDraft>>>
    export type SaveAdminFfCardDraftMutationBody = BodyType<AdminFfCardDraftUpdate>
    export type SaveAdminFfCardDraftMutationError = ErrorType<FfCardsErrorResponse>

    export const useSaveAdminFfCardDraft = <TError = ErrorType<FfCardsErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveAdminFfCardDraft>>, TError,{id: number;data: BodyType<AdminFfCardDraftUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof saveAdminFfCardDraft>>,
        TError,
        {id: number;data: BodyType<AdminFfCardDraftUpdate>},
        TContext
      > => {
      return useMutation(getSaveAdminFfCardDraftMutationOptions(options));
    }

export const getPublishAdminFfCardUrl = (id: number,) => {




  return `/api/admin/flashcards/${id}/publish`
}

export const publishAdminFfCard = async (id: number,
    adminFfCardPublish: AdminFfCardPublish, options?: RequestInit): Promise<AdminFfCardWorkspace> => {

  return customFetch<AdminFfCardWorkspace>(getPublishAdminFfCardUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      adminFfCardPublish,)
  }
);}




export const getPublishAdminFfCardMutationOptions = <TError = ErrorType<FfCardsErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishAdminFfCard>>, TError,{id: number;data: BodyType<AdminFfCardPublish>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof publishAdminFfCard>>, TError,{id: number;data: BodyType<AdminFfCardPublish>}, TContext> => {

const mutationKey = ['publishAdminFfCard'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof publishAdminFfCard>>, {id: number;data: BodyType<AdminFfCardPublish>}> = (props) => {
          const {id,data} = props ?? {};

          return  publishAdminFfCard(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PublishAdminFfCardMutationResult = NonNullable<Awaited<ReturnType<typeof publishAdminFfCard>>>
    export type PublishAdminFfCardMutationBody = BodyType<AdminFfCardPublish>
    export type PublishAdminFfCardMutationError = ErrorType<FfCardsErrorResponse>

    export const usePublishAdminFfCard = <TError = ErrorType<FfCardsErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishAdminFfCard>>, TError,{id: number;data: BodyType<AdminFfCardPublish>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof publishAdminFfCard>>,
        TError,
        {id: number;data: BodyType<AdminFfCardPublish>},
        TContext
      > => {
      return useMutation(getPublishAdminFfCardMutationOptions(options));
    }

export const getListAdminFfCardVersionsUrl = (id: number,) => {




  return `/api/admin/flashcards/${id}/versions`
}

export const listAdminFfCardVersions = async (id: number, options?: RequestInit): Promise<AdminFfCardVersion[]> => {

  return customFetch<AdminFfCardVersion[]>(getListAdminFfCardVersionsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminFfCardVersionsQueryKey = (id: number,) => {
    return [
    `/api/admin/flashcards/${id}/versions`
    ] as const;
    }


export const getListAdminFfCardVersionsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminFfCardVersions>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminFfCardVersions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminFfCardVersionsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminFfCardVersions>>> = ({ signal }) => listAdminFfCardVersions(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminFfCardVersions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAdminFfCardVersionsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminFfCardVersions>>>
export type ListAdminFfCardVersionsQueryError = ErrorType<unknown>



export function useListAdminFfCardVersions<TData = Awaited<ReturnType<typeof listAdminFfCardVersions>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminFfCardVersions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAdminFfCardVersionsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetAdminFfCardVersionUrl = (id: number,
    versionId: string,) => {




  return `/api/admin/flashcards/${id}/versions/${versionId}`
}

export const getAdminFfCardVersion = async (id: number,
    versionId: string, options?: RequestInit): Promise<AdminFfCardVersion> => {

  return customFetch<AdminFfCardVersion>(getGetAdminFfCardVersionUrl(id,versionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminFfCardVersionQueryKey = (id: number,
    versionId: string,) => {
    return [
    `/api/admin/flashcards/${id}/versions/${versionId}`
    ] as const;
    }


export const getGetAdminFfCardVersionQueryOptions = <TData = Awaited<ReturnType<typeof getAdminFfCardVersion>>, TError = ErrorType<unknown>>(id: number,
    versionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminFfCardVersion>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminFfCardVersionQueryKey(id,versionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminFfCardVersion>>> = ({ signal }) => getAdminFfCardVersion(id,versionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminFfCardVersion>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminFfCardVersionQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminFfCardVersion>>>
export type GetAdminFfCardVersionQueryError = ErrorType<unknown>



export function useGetAdminFfCardVersion<TData = Awaited<ReturnType<typeof getAdminFfCardVersion>>, TError = ErrorType<unknown>>(
 id: number,
    versionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminFfCardVersion>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminFfCardVersionQueryOptions(id,versionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getArchiveAdminFfCardUrl = (id: number,) => {




  return `/api/admin/flashcards/${id}/archive`
}

export const archiveAdminFfCard = async (id: number, options?: RequestInit): Promise<AdminFfCardWorkspace> => {

  return customFetch<AdminFfCardWorkspace>(getArchiveAdminFfCardUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getArchiveAdminFfCardMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveAdminFfCard>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof archiveAdminFfCard>>, TError,{id: number}, TContext> => {

const mutationKey = ['archiveAdminFfCard'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveAdminFfCard>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  archiveAdminFfCard(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveAdminFfCardMutationResult = NonNullable<Awaited<ReturnType<typeof archiveAdminFfCard>>>

    export type ArchiveAdminFfCardMutationError = ErrorType<unknown>

    export const useArchiveAdminFfCard = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveAdminFfCard>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof archiveAdminFfCard>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getArchiveAdminFfCardMutationOptions(options));
    }

export const getDeactivateAdminFfCardUrl = (id: number,) => {




  return `/api/admin/flashcards/${id}/deactivate`
}

export const deactivateAdminFfCard = async (id: number, options?: RequestInit): Promise<AdminFfCardWorkspace> => {

  return customFetch<AdminFfCardWorkspace>(getDeactivateAdminFfCardUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getDeactivateAdminFfCardMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateAdminFfCard>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deactivateAdminFfCard>>, TError,{id: number}, TContext> => {

const mutationKey = ['deactivateAdminFfCard'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deactivateAdminFfCard>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deactivateAdminFfCard(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeactivateAdminFfCardMutationResult = NonNullable<Awaited<ReturnType<typeof deactivateAdminFfCard>>>

    export type DeactivateAdminFfCardMutationError = ErrorType<unknown>

    export const useDeactivateAdminFfCard = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateAdminFfCard>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deactivateAdminFfCard>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeactivateAdminFfCardMutationOptions(options));
    }

export const getReactivateAdminFfCardUrl = (id: number,) => {




  return `/api/admin/flashcards/${id}/reactivate`
}

export const reactivateAdminFfCard = async (id: number, options?: RequestInit): Promise<AdminFfCardWorkspace> => {

  return customFetch<AdminFfCardWorkspace>(getReactivateAdminFfCardUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getReactivateAdminFfCardMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reactivateAdminFfCard>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reactivateAdminFfCard>>, TError,{id: number}, TContext> => {

const mutationKey = ['reactivateAdminFfCard'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reactivateAdminFfCard>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  reactivateAdminFfCard(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReactivateAdminFfCardMutationResult = NonNullable<Awaited<ReturnType<typeof reactivateAdminFfCard>>>

    export type ReactivateAdminFfCardMutationError = ErrorType<unknown>

    export const useReactivateAdminFfCard = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reactivateAdminFfCard>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reactivateAdminFfCard>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getReactivateAdminFfCardMutationOptions(options));
    }

export const getListVideosUrl = (params?: ListVideosParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/videos?${stringifiedParams}` : `/api/admin/videos`
}

/**
 * @summary List videos
 */
export const listVideos = async (params?: ListVideosParams, options?: RequestInit): Promise<Video[]> => {

  return customFetch<Video[]>(getListVideosUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListVideosQueryKey = (params?: ListVideosParams,) => {
    return [
    `/api/admin/videos`, ...(params ? [params] : [])
    ] as const;
    }


export const getListVideosQueryOptions = <TData = Awaited<ReturnType<typeof listVideos>>, TError = ErrorType<unknown>>(params?: ListVideosParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listVideos>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListVideosQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listVideos>>> = ({ signal }) => listVideos(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listVideos>>, TError, TData> & { queryKey: QueryKey }
}

export type ListVideosQueryResult = NonNullable<Awaited<ReturnType<typeof listVideos>>>
export type ListVideosQueryError = ErrorType<unknown>


/**
 * @summary List videos
 */

export function useListVideos<TData = Awaited<ReturnType<typeof listVideos>>, TError = ErrorType<unknown>>(
 params?: ListVideosParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listVideos>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListVideosQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateVideoUrl = () => {




  return `/api/admin/videos`
}

/**
 * @summary Create video
 */
export const createVideo = async (videoInput: VideoInput, options?: RequestInit): Promise<Video> => {

  return customFetch<Video>(getCreateVideoUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      videoInput,)
  }
);}




export const getCreateVideoMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVideo>>, TError,{data: BodyType<VideoInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createVideo>>, TError,{data: BodyType<VideoInput>}, TContext> => {

const mutationKey = ['createVideo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVideo>>, {data: BodyType<VideoInput>}> = (props) => {
          const {data} = props ?? {};

          return  createVideo(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateVideoMutationResult = NonNullable<Awaited<ReturnType<typeof createVideo>>>
    export type CreateVideoMutationBody = BodyType<VideoInput>
    export type CreateVideoMutationError = ErrorType<unknown>

    /**
 * @summary Create video
 */
export const useCreateVideo = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVideo>>, TError,{data: BodyType<VideoInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createVideo>>,
        TError,
        {data: BodyType<VideoInput>},
        TContext
      > => {
      return useMutation(getCreateVideoMutationOptions(options));
    }

export const getUpdateVideoUrl = (id: number,) => {




  return `/api/admin/videos/${id}`
}

/**
 * @summary Update video
 */
export const updateVideo = async (id: number,
    videoUpdate: VideoUpdate, options?: RequestInit): Promise<Video> => {

  return customFetch<Video>(getUpdateVideoUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      videoUpdate,)
  }
);}




export const getUpdateVideoMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVideo>>, TError,{id: number;data: BodyType<VideoUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateVideo>>, TError,{id: number;data: BodyType<VideoUpdate>}, TContext> => {

const mutationKey = ['updateVideo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVideo>>, {id: number;data: BodyType<VideoUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateVideo(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateVideoMutationResult = NonNullable<Awaited<ReturnType<typeof updateVideo>>>
    export type UpdateVideoMutationBody = BodyType<VideoUpdate>
    export type UpdateVideoMutationError = ErrorType<unknown>

    /**
 * @summary Update video
 */
export const useUpdateVideo = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVideo>>, TError,{id: number;data: BodyType<VideoUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateVideo>>,
        TError,
        {id: number;data: BodyType<VideoUpdate>},
        TContext
      > => {
      return useMutation(getUpdateVideoMutationOptions(options));
    }

export const getDeleteVideoUrl = (id: number,) => {




  return `/api/admin/videos/${id}`
}

/**
 * @summary Delete video
 */
export const deleteVideo = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteVideoUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteVideoMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVideo>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteVideo>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteVideo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteVideo>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteVideo(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteVideoMutationResult = NonNullable<Awaited<ReturnType<typeof deleteVideo>>>

    export type DeleteVideoMutationError = ErrorType<unknown>

    /**
 * @summary Delete video
 */
export const useDeleteVideo = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVideo>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteVideo>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteVideoMutationOptions(options));
    }

export const getListSolicitacoesUrl = (params?: ListSolicitacoesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/solicitacoes?${stringifiedParams}` : `/api/admin/solicitacoes`
}

/**
 * @summary List solicitações
 */
export const listSolicitacoes = async (params?: ListSolicitacoesParams, options?: RequestInit): Promise<Solicitacao[]> => {

  return customFetch<Solicitacao[]>(getListSolicitacoesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSolicitacoesQueryKey = (params?: ListSolicitacoesParams,) => {
    return [
    `/api/admin/solicitacoes`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSolicitacoesQueryOptions = <TData = Awaited<ReturnType<typeof listSolicitacoes>>, TError = ErrorType<unknown>>(params?: ListSolicitacoesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSolicitacoes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSolicitacoesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSolicitacoes>>> = ({ signal }) => listSolicitacoes(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSolicitacoes>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSolicitacoesQueryResult = NonNullable<Awaited<ReturnType<typeof listSolicitacoes>>>
export type ListSolicitacoesQueryError = ErrorType<unknown>


/**
 * @summary List solicitações
 */

export function useListSolicitacoes<TData = Awaited<ReturnType<typeof listSolicitacoes>>, TError = ErrorType<unknown>>(
 params?: ListSolicitacoesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSolicitacoes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSolicitacoesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListStudentSuggestionsUrl = () => {




  return `/api/mobile/sugestoes`
}

/**
 * @summary List suggestions created by the authenticated student
 */
export const listStudentSuggestions = async ( options?: RequestInit): Promise<Suggestion[]> => {

  return customFetch<Suggestion[]>(getListStudentSuggestionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListStudentSuggestionsQueryKey = () => {
    return [
    `/api/mobile/sugestoes`
    ] as const;
    }


export const getListStudentSuggestionsQueryOptions = <TData = Awaited<ReturnType<typeof listStudentSuggestions>>, TError = ErrorType<UnauthorizedResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listStudentSuggestions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListStudentSuggestionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listStudentSuggestions>>> = ({ signal }) => listStudentSuggestions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listStudentSuggestions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListStudentSuggestionsQueryResult = NonNullable<Awaited<ReturnType<typeof listStudentSuggestions>>>
export type ListStudentSuggestionsQueryError = ErrorType<UnauthorizedResponse>


/**
 * @summary List suggestions created by the authenticated student
 */

export function useListStudentSuggestions<TData = Awaited<ReturnType<typeof listStudentSuggestions>>, TError = ErrorType<UnauthorizedResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listStudentSuggestions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListStudentSuggestionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateStudentSuggestionUrl = () => {




  return `/api/mobile/sugestoes`
}

/**
 * @summary Submit a suggestion as the authenticated student
 */
export const createStudentSuggestion = async (createSuggestionInput: CreateSuggestionInput, options?: RequestInit): Promise<Suggestion> => {

  return customFetch<Suggestion>(getCreateStudentSuggestionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createSuggestionInput,)
  }
);}




export const getCreateStudentSuggestionMutationOptions = <TError = ErrorType<ValidationErrorResponse | UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStudentSuggestion>>, TError,{data: BodyType<CreateSuggestionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createStudentSuggestion>>, TError,{data: BodyType<CreateSuggestionInput>}, TContext> => {

const mutationKey = ['createStudentSuggestion'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createStudentSuggestion>>, {data: BodyType<CreateSuggestionInput>}> = (props) => {
          const {data} = props ?? {};

          return  createStudentSuggestion(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateStudentSuggestionMutationResult = NonNullable<Awaited<ReturnType<typeof createStudentSuggestion>>>
    export type CreateStudentSuggestionMutationBody = BodyType<CreateSuggestionInput>
    export type CreateStudentSuggestionMutationError = ErrorType<ValidationErrorResponse | UnauthorizedResponse>

    /**
 * @summary Submit a suggestion as the authenticated student
 */
export const useCreateStudentSuggestion = <TError = ErrorType<ValidationErrorResponse | UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStudentSuggestion>>, TError,{data: BodyType<CreateSuggestionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createStudentSuggestion>>,
        TError,
        {data: BodyType<CreateSuggestionInput>},
        TContext
      > => {
      return useMutation(getCreateStudentSuggestionMutationOptions(options));
    }

export const getGetStudyProfileUrl = () => {




  return `/api/mobile/study-profile`
}

export const getStudyProfile = async ( options?: RequestInit): Promise<StudyProfile> => {

  return customFetch<StudyProfile>(getGetStudyProfileUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStudyProfileQueryKey = () => {
    return [
    `/api/mobile/study-profile`
    ] as const;
    }


export const getGetStudyProfileQueryOptions = <TData = Awaited<ReturnType<typeof getStudyProfile>>, TError = ErrorType<UnauthorizedResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStudyProfile>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStudyProfileQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStudyProfile>>> = ({ signal }) => getStudyProfile({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStudyProfile>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStudyProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getStudyProfile>>>
export type GetStudyProfileQueryError = ErrorType<UnauthorizedResponse>



export function useGetStudyProfile<TData = Awaited<ReturnType<typeof getStudyProfile>>, TError = ErrorType<UnauthorizedResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStudyProfile>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStudyProfileQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateStudyProfileUrl = () => {




  return `/api/mobile/study-profile`
}

export const updateStudyProfile = async (studyProfileInput: StudyProfileInput, options?: RequestInit): Promise<StudyProfile> => {

  return customFetch<StudyProfile>(getUpdateStudyProfileUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      studyProfileInput,)
  }
);}




export const getUpdateStudyProfileMutationOptions = <TError = ErrorType<ValidationErrorResponse | UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStudyProfile>>, TError,{data: BodyType<StudyProfileInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateStudyProfile>>, TError,{data: BodyType<StudyProfileInput>}, TContext> => {

const mutationKey = ['updateStudyProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateStudyProfile>>, {data: BodyType<StudyProfileInput>}> = (props) => {
          const {data} = props ?? {};

          return  updateStudyProfile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateStudyProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updateStudyProfile>>>
    export type UpdateStudyProfileMutationBody = BodyType<StudyProfileInput>
    export type UpdateStudyProfileMutationError = ErrorType<ValidationErrorResponse | UnauthorizedResponse>

    export const useUpdateStudyProfile = <TError = ErrorType<ValidationErrorResponse | UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStudyProfile>>, TError,{data: BodyType<StudyProfileInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateStudyProfile>>,
        TError,
        {data: BodyType<StudyProfileInput>},
        TContext
      > => {
      return useMutation(getUpdateStudyProfileMutationOptions(options));
    }

export const getListMobileBancasUrl = () => {




  return `/api/mobile/bancas`
}

export const listMobileBancas = async ( options?: RequestInit): Promise<MobileBanca[]> => {

  return customFetch<MobileBanca[]>(getListMobileBancasUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMobileBancasQueryKey = () => {
    return [
    `/api/mobile/bancas`
    ] as const;
    }


export const getListMobileBancasQueryOptions = <TData = Awaited<ReturnType<typeof listMobileBancas>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMobileBancas>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMobileBancasQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMobileBancas>>> = ({ signal }) => listMobileBancas({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMobileBancas>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMobileBancasQueryResult = NonNullable<Awaited<ReturnType<typeof listMobileBancas>>>
export type ListMobileBancasQueryError = ErrorType<unknown>



export function useListMobileBancas<TData = Awaited<ReturnType<typeof listMobileBancas>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMobileBancas>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMobileBancasQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListMobileConcursosUrl = () => {




  return `/api/mobile/concursos`
}

export const listMobileConcursos = async ( options?: RequestInit): Promise<MobileConcurso[]> => {

  return customFetch<MobileConcurso[]>(getListMobileConcursosUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMobileConcursosQueryKey = () => {
    return [
    `/api/mobile/concursos`
    ] as const;
    }


export const getListMobileConcursosQueryOptions = <TData = Awaited<ReturnType<typeof listMobileConcursos>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMobileConcursos>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMobileConcursosQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMobileConcursos>>> = ({ signal }) => listMobileConcursos({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMobileConcursos>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMobileConcursosQueryResult = NonNullable<Awaited<ReturnType<typeof listMobileConcursos>>>
export type ListMobileConcursosQueryError = ErrorType<unknown>



export function useListMobileConcursos<TData = Awaited<ReturnType<typeof listMobileConcursos>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMobileConcursos>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMobileConcursosQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListConcursosUrl = () => {




  return `/api/admin/concursos`
}

export const listConcursos = async ( options?: RequestInit): Promise<Concurso[]> => {

  return customFetch<Concurso[]>(getListConcursosUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListConcursosQueryKey = () => {
    return [
    `/api/admin/concursos`
    ] as const;
    }


export const getListConcursosQueryOptions = <TData = Awaited<ReturnType<typeof listConcursos>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listConcursos>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListConcursosQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listConcursos>>> = ({ signal }) => listConcursos({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listConcursos>>, TError, TData> & { queryKey: QueryKey }
}

export type ListConcursosQueryResult = NonNullable<Awaited<ReturnType<typeof listConcursos>>>
export type ListConcursosQueryError = ErrorType<unknown>



export function useListConcursos<TData = Awaited<ReturnType<typeof listConcursos>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listConcursos>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListConcursosQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateConcursoUrl = () => {




  return `/api/admin/concursos`
}

export const createConcurso = async (concursoInput: ConcursoInput, options?: RequestInit): Promise<Concurso> => {

  return customFetch<Concurso>(getCreateConcursoUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      concursoInput,)
  }
);}




export const getCreateConcursoMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createConcurso>>, TError,{data: BodyType<ConcursoInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createConcurso>>, TError,{data: BodyType<ConcursoInput>}, TContext> => {

const mutationKey = ['createConcurso'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createConcurso>>, {data: BodyType<ConcursoInput>}> = (props) => {
          const {data} = props ?? {};

          return  createConcurso(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateConcursoMutationResult = NonNullable<Awaited<ReturnType<typeof createConcurso>>>
    export type CreateConcursoMutationBody = BodyType<ConcursoInput>
    export type CreateConcursoMutationError = ErrorType<unknown>

    export const useCreateConcurso = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createConcurso>>, TError,{data: BodyType<ConcursoInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createConcurso>>,
        TError,
        {data: BodyType<ConcursoInput>},
        TContext
      > => {
      return useMutation(getCreateConcursoMutationOptions(options));
    }

export const getUpdateConcursoUrl = (id: number,) => {




  return `/api/admin/concursos/${id}`
}

export const updateConcurso = async (id: number,
    concursoInput: ConcursoInput, options?: RequestInit): Promise<Concurso> => {

  return customFetch<Concurso>(getUpdateConcursoUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      concursoInput,)
  }
);}




export const getUpdateConcursoMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateConcurso>>, TError,{id: number;data: BodyType<ConcursoInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateConcurso>>, TError,{id: number;data: BodyType<ConcursoInput>}, TContext> => {

const mutationKey = ['updateConcurso'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateConcurso>>, {id: number;data: BodyType<ConcursoInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateConcurso(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateConcursoMutationResult = NonNullable<Awaited<ReturnType<typeof updateConcurso>>>
    export type UpdateConcursoMutationBody = BodyType<ConcursoInput>
    export type UpdateConcursoMutationError = ErrorType<unknown>

    export const useUpdateConcurso = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateConcurso>>, TError,{id: number;data: BodyType<ConcursoInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateConcurso>>,
        TError,
        {id: number;data: BodyType<ConcursoInput>},
        TContext
      > => {
      return useMutation(getUpdateConcursoMutationOptions(options));
    }

export const getUpdateConcursoConteudosUrl = (id: number,) => {




  return `/api/admin/concursos/${id}/conteudos`
}

export const updateConcursoConteudos = async (id: number,
    updateConcursoConteudosBody: UpdateConcursoConteudosBody, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getUpdateConcursoConteudosUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateConcursoConteudosBody,)
  }
);}




export const getUpdateConcursoConteudosMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateConcursoConteudos>>, TError,{id: number;data: BodyType<UpdateConcursoConteudosBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateConcursoConteudos>>, TError,{id: number;data: BodyType<UpdateConcursoConteudosBody>}, TContext> => {

const mutationKey = ['updateConcursoConteudos'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateConcursoConteudos>>, {id: number;data: BodyType<UpdateConcursoConteudosBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateConcursoConteudos(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateConcursoConteudosMutationResult = NonNullable<Awaited<ReturnType<typeof updateConcursoConteudos>>>
    export type UpdateConcursoConteudosMutationBody = BodyType<UpdateConcursoConteudosBody>
    export type UpdateConcursoConteudosMutationError = ErrorType<unknown>

    export const useUpdateConcursoConteudos = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateConcursoConteudos>>, TError,{id: number;data: BodyType<UpdateConcursoConteudosBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateConcursoConteudos>>,
        TError,
        {id: number;data: BodyType<UpdateConcursoConteudosBody>},
        TContext
      > => {
      return useMutation(getUpdateConcursoConteudosMutationOptions(options));
    }

export const getUpdateSolicitacaoStatusUrl = (id: number,) => {




  return `/api/admin/solicitacoes/${id}/status`
}

/**
 * @summary Update solicitação status
 */
export const updateSolicitacaoStatus = async (id: number,
    solicitacaoStatusInput: SolicitacaoStatusInput, options?: RequestInit): Promise<Solicitacao> => {

  return customFetch<Solicitacao>(getUpdateSolicitacaoStatusUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      solicitacaoStatusInput,)
  }
);}




export const getUpdateSolicitacaoStatusMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSolicitacaoStatus>>, TError,{id: number;data: BodyType<SolicitacaoStatusInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSolicitacaoStatus>>, TError,{id: number;data: BodyType<SolicitacaoStatusInput>}, TContext> => {

const mutationKey = ['updateSolicitacaoStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSolicitacaoStatus>>, {id: number;data: BodyType<SolicitacaoStatusInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateSolicitacaoStatus(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSolicitacaoStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateSolicitacaoStatus>>>
    export type UpdateSolicitacaoStatusMutationBody = BodyType<SolicitacaoStatusInput>
    export type UpdateSolicitacaoStatusMutationError = ErrorType<unknown>

    /**
 * @summary Update solicitação status
 */
export const useUpdateSolicitacaoStatus = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSolicitacaoStatus>>, TError,{id: number;data: BodyType<SolicitacaoStatusInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSolicitacaoStatus>>,
        TError,
        {id: number;data: BodyType<SolicitacaoStatusInput>},
        TContext
      > => {
      return useMutation(getUpdateSolicitacaoStatusMutationOptions(options));
    }

export const getCreateRelatoUrl = () => {




  return `/api/relatos`
}

/**
 * @summary Report an error (public, mobile)
 */
export const createRelato = async (relatoInput: RelatoInput, options?: RequestInit): Promise<Relato> => {

  return customFetch<Relato>(getCreateRelatoUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      relatoInput,)
  }
);}




export const getCreateRelatoMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRelato>>, TError,{data: BodyType<RelatoInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createRelato>>, TError,{data: BodyType<RelatoInput>}, TContext> => {

const mutationKey = ['createRelato'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRelato>>, {data: BodyType<RelatoInput>}> = (props) => {
          const {data} = props ?? {};

          return  createRelato(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateRelatoMutationResult = NonNullable<Awaited<ReturnType<typeof createRelato>>>
    export type CreateRelatoMutationBody = BodyType<RelatoInput>
    export type CreateRelatoMutationError = ErrorType<unknown>

    /**
 * @summary Report an error (public, mobile)
 */
export const useCreateRelato = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRelato>>, TError,{data: BodyType<RelatoInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createRelato>>,
        TError,
        {data: BodyType<RelatoInput>},
        TContext
      > => {
      return useMutation(getCreateRelatoMutationOptions(options));
    }

export const getListRelatosUrl = (params?: ListRelatosParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/relatos?${stringifiedParams}` : `/api/admin/relatos`
}

/**
 * @summary List relatos de erros
 */
export const listRelatos = async (params?: ListRelatosParams, options?: RequestInit): Promise<Relato[]> => {

  return customFetch<Relato[]>(getListRelatosUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRelatosQueryKey = (params?: ListRelatosParams,) => {
    return [
    `/api/admin/relatos`, ...(params ? [params] : [])
    ] as const;
    }


export const getListRelatosQueryOptions = <TData = Awaited<ReturnType<typeof listRelatos>>, TError = ErrorType<unknown>>(params?: ListRelatosParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRelatos>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRelatosQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRelatos>>> = ({ signal }) => listRelatos(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRelatos>>, TError, TData> & { queryKey: QueryKey }
}

export type ListRelatosQueryResult = NonNullable<Awaited<ReturnType<typeof listRelatos>>>
export type ListRelatosQueryError = ErrorType<unknown>


/**
 * @summary List relatos de erros
 */

export function useListRelatos<TData = Awaited<ReturnType<typeof listRelatos>>, TError = ErrorType<unknown>>(
 params?: ListRelatosParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRelatos>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListRelatosQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateRelatoStatusUrl = (id: number,) => {




  return `/api/admin/relatos/${id}/status`
}

/**
 * @summary Update relato status
 */
export const updateRelatoStatus = async (id: number,
    relatoStatusInput: RelatoStatusInput, options?: RequestInit): Promise<Relato> => {

  return customFetch<Relato>(getUpdateRelatoStatusUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      relatoStatusInput,)
  }
);}




export const getUpdateRelatoStatusMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRelatoStatus>>, TError,{id: number;data: BodyType<RelatoStatusInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateRelatoStatus>>, TError,{id: number;data: BodyType<RelatoStatusInput>}, TContext> => {

const mutationKey = ['updateRelatoStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRelatoStatus>>, {id: number;data: BodyType<RelatoStatusInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateRelatoStatus(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateRelatoStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateRelatoStatus>>>
    export type UpdateRelatoStatusMutationBody = BodyType<RelatoStatusInput>
    export type UpdateRelatoStatusMutationError = ErrorType<unknown>

    /**
 * @summary Update relato status
 */
export const useUpdateRelatoStatus = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRelatoStatus>>, TError,{id: number;data: BodyType<RelatoStatusInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateRelatoStatus>>,
        TError,
        {id: number;data: BodyType<RelatoStatusInput>},
        TContext
      > => {
      return useMutation(getUpdateRelatoStatusMutationOptions(options));
    }

export const getListUsuariosUrl = () => {




  return `/api/admin/usuarios`
}

/**
 * @summary List usuários
 */
export const listUsuarios = async ( options?: RequestInit): Promise<Usuario[]> => {

  return customFetch<Usuario[]>(getListUsuariosUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListUsuariosQueryKey = () => {
    return [
    `/api/admin/usuarios`
    ] as const;
    }


export const getListUsuariosQueryOptions = <TData = Awaited<ReturnType<typeof listUsuarios>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listUsuarios>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUsuariosQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUsuarios>>> = ({ signal }) => listUsuarios({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUsuarios>>, TError, TData> & { queryKey: QueryKey }
}

export type ListUsuariosQueryResult = NonNullable<Awaited<ReturnType<typeof listUsuarios>>>
export type ListUsuariosQueryError = ErrorType<unknown>


/**
 * @summary List usuários
 */

export function useListUsuarios<TData = Awaited<ReturnType<typeof listUsuarios>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listUsuarios>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListUsuariosQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateUsuarioStatusUrl = (id: number,) => {




  return `/api/admin/usuarios/${id}/status`
}

export const updateUsuarioStatus = async (id: number,
    updateUsuarioStatusBody: UpdateUsuarioStatusBody, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getUpdateUsuarioStatusUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateUsuarioStatusBody,)
  }
);}




export const getUpdateUsuarioStatusMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUsuarioStatus>>, TError,{id: number;data: BodyType<UpdateUsuarioStatusBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateUsuarioStatus>>, TError,{id: number;data: BodyType<UpdateUsuarioStatusBody>}, TContext> => {

const mutationKey = ['updateUsuarioStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUsuarioStatus>>, {id: number;data: BodyType<UpdateUsuarioStatusBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateUsuarioStatus(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateUsuarioStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateUsuarioStatus>>>
    export type UpdateUsuarioStatusMutationBody = BodyType<UpdateUsuarioStatusBody>
    export type UpdateUsuarioStatusMutationError = ErrorType<void>

    export const useUpdateUsuarioStatus = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUsuarioStatus>>, TError,{id: number;data: BodyType<UpdateUsuarioStatusBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateUsuarioStatus>>,
        TError,
        {id: number;data: BodyType<UpdateUsuarioStatusBody>},
        TContext
      > => {
      return useMutation(getUpdateUsuarioStatusMutationOptions(options));
    }

export const getListPlanosUrl = () => {




  return `/api/admin/planos`
}

/**
 * @summary List planos
 */
export const listPlanos = async ( options?: RequestInit): Promise<Plan[]> => {

  return customFetch<Plan[]>(getListPlanosUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPlanosQueryKey = () => {
    return [
    `/api/admin/planos`
    ] as const;
    }


export const getListPlanosQueryOptions = <TData = Awaited<ReturnType<typeof listPlanos>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPlanos>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPlanosQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPlanos>>> = ({ signal }) => listPlanos({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPlanos>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPlanosQueryResult = NonNullable<Awaited<ReturnType<typeof listPlanos>>>
export type ListPlanosQueryError = ErrorType<unknown>


/**
 * @summary List planos
 */

export function useListPlanos<TData = Awaited<ReturnType<typeof listPlanos>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPlanos>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPlanosQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreatePlanoUrl = () => {




  return `/api/admin/planos`
}

/**
 * @summary Create plano
 */
export const createPlano = async (planInput: PlanInput, options?: RequestInit): Promise<Plan> => {

  return customFetch<Plan>(getCreatePlanoUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      planInput,)
  }
);}




export const getCreatePlanoMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPlano>>, TError,{data: BodyType<PlanInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPlano>>, TError,{data: BodyType<PlanInput>}, TContext> => {

const mutationKey = ['createPlano'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPlano>>, {data: BodyType<PlanInput>}> = (props) => {
          const {data} = props ?? {};

          return  createPlano(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePlanoMutationResult = NonNullable<Awaited<ReturnType<typeof createPlano>>>
    export type CreatePlanoMutationBody = BodyType<PlanInput>
    export type CreatePlanoMutationError = ErrorType<unknown>

    /**
 * @summary Create plano
 */
export const useCreatePlano = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPlano>>, TError,{data: BodyType<PlanInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPlano>>,
        TError,
        {data: BodyType<PlanInput>},
        TContext
      > => {
      return useMutation(getCreatePlanoMutationOptions(options));
    }

export const getGetPlanoUrl = (id: number,) => {




  return `/api/admin/planos/${id}`
}

/**
 * @summary Get plano
 */
export const getPlano = async (id: number, options?: RequestInit): Promise<Plan> => {

  return customFetch<Plan>(getGetPlanoUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPlanoQueryKey = (id: number,) => {
    return [
    `/api/admin/planos/${id}`
    ] as const;
    }


export const getGetPlanoQueryOptions = <TData = Awaited<ReturnType<typeof getPlano>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlano>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlanoQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlano>>> = ({ signal }) => getPlano(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlano>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPlanoQueryResult = NonNullable<Awaited<ReturnType<typeof getPlano>>>
export type GetPlanoQueryError = ErrorType<unknown>


/**
 * @summary Get plano
 */

export function useGetPlano<TData = Awaited<ReturnType<typeof getPlano>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlano>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPlanoQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdatePlanoUrl = (id: number,) => {




  return `/api/admin/planos/${id}`
}

/**
 * @summary Update plano
 */
export const updatePlano = async (id: number,
    planInput: PlanInput, options?: RequestInit): Promise<Plan> => {

  return customFetch<Plan>(getUpdatePlanoUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      planInput,)
  }
);}




export const getUpdatePlanoMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlano>>, TError,{id: number;data: BodyType<PlanInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePlano>>, TError,{id: number;data: BodyType<PlanInput>}, TContext> => {

const mutationKey = ['updatePlano'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePlano>>, {id: number;data: BodyType<PlanInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updatePlano(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePlanoMutationResult = NonNullable<Awaited<ReturnType<typeof updatePlano>>>
    export type UpdatePlanoMutationBody = BodyType<PlanInput>
    export type UpdatePlanoMutationError = ErrorType<unknown>

    /**
 * @summary Update plano
 */
export const useUpdatePlano = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlano>>, TError,{id: number;data: BodyType<PlanInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePlano>>,
        TError,
        {id: number;data: BodyType<PlanInput>},
        TContext
      > => {
      return useMutation(getUpdatePlanoMutationOptions(options));
    }

export const getDeletePlanoUrl = (id: number,) => {




  return `/api/admin/planos/${id}`
}

/**
 * @summary Delete plano
 */
export const deletePlano = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeletePlanoUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeletePlanoMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePlano>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePlano>>, TError,{id: number}, TContext> => {

const mutationKey = ['deletePlano'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePlano>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deletePlano(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePlanoMutationResult = NonNullable<Awaited<ReturnType<typeof deletePlano>>>

    export type DeletePlanoMutationError = ErrorType<unknown>

    /**
 * @summary Delete plano
 */
export const useDeletePlano = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePlano>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePlano>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeletePlanoMutationOptions(options));
    }

export const getListAssinaturasUrl = () => {




  return `/api/admin/assinaturas`
}

/**
 * @summary List assinaturas
 */
export const listAssinaturas = async ( options?: RequestInit): Promise<SubscriptionWithRelations[]> => {

  return customFetch<SubscriptionWithRelations[]>(getListAssinaturasUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAssinaturasQueryKey = () => {
    return [
    `/api/admin/assinaturas`
    ] as const;
    }


export const getListAssinaturasQueryOptions = <TData = Awaited<ReturnType<typeof listAssinaturas>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAssinaturas>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAssinaturasQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAssinaturas>>> = ({ signal }) => listAssinaturas({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAssinaturas>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAssinaturasQueryResult = NonNullable<Awaited<ReturnType<typeof listAssinaturas>>>
export type ListAssinaturasQueryError = ErrorType<unknown>


/**
 * @summary List assinaturas
 */

export function useListAssinaturas<TData = Awaited<ReturnType<typeof listAssinaturas>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAssinaturas>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAssinaturasQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateAssinaturaUrl = () => {




  return `/api/admin/assinaturas`
}

/**
 * @summary Create assinatura
 */
export const createAssinatura = async (subscriptionInput: SubscriptionInput, options?: RequestInit): Promise<Subscription> => {

  return customFetch<Subscription>(getCreateAssinaturaUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      subscriptionInput,)
  }
);}




export const getCreateAssinaturaMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAssinatura>>, TError,{data: BodyType<SubscriptionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAssinatura>>, TError,{data: BodyType<SubscriptionInput>}, TContext> => {

const mutationKey = ['createAssinatura'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAssinatura>>, {data: BodyType<SubscriptionInput>}> = (props) => {
          const {data} = props ?? {};

          return  createAssinatura(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAssinaturaMutationResult = NonNullable<Awaited<ReturnType<typeof createAssinatura>>>
    export type CreateAssinaturaMutationBody = BodyType<SubscriptionInput>
    export type CreateAssinaturaMutationError = ErrorType<unknown>

    /**
 * @summary Create assinatura
 */
export const useCreateAssinatura = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAssinatura>>, TError,{data: BodyType<SubscriptionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAssinatura>>,
        TError,
        {data: BodyType<SubscriptionInput>},
        TContext
      > => {
      return useMutation(getCreateAssinaturaMutationOptions(options));
    }

export const getUpdateAssinaturaUrl = (id: number,) => {




  return `/api/admin/assinaturas/${id}`
}

/**
 * @summary Update assinatura
 */
export const updateAssinatura = async (id: number,
    subscriptionInput: SubscriptionInput, options?: RequestInit): Promise<Subscription> => {

  return customFetch<Subscription>(getUpdateAssinaturaUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      subscriptionInput,)
  }
);}




export const getUpdateAssinaturaMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAssinatura>>, TError,{id: number;data: BodyType<SubscriptionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAssinatura>>, TError,{id: number;data: BodyType<SubscriptionInput>}, TContext> => {

const mutationKey = ['updateAssinatura'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAssinatura>>, {id: number;data: BodyType<SubscriptionInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateAssinatura(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAssinaturaMutationResult = NonNullable<Awaited<ReturnType<typeof updateAssinatura>>>
    export type UpdateAssinaturaMutationBody = BodyType<SubscriptionInput>
    export type UpdateAssinaturaMutationError = ErrorType<unknown>

    /**
 * @summary Update assinatura
 */
export const useUpdateAssinatura = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAssinatura>>, TError,{id: number;data: BodyType<SubscriptionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAssinatura>>,
        TError,
        {id: number;data: BodyType<SubscriptionInput>},
        TContext
      > => {
      return useMutation(getUpdateAssinaturaMutationOptions(options));
    }

export const getDeleteAssinaturaUrl = (id: number,) => {




  return `/api/admin/assinaturas/${id}`
}

/**
 * @summary Delete assinatura
 */
export const deleteAssinatura = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteAssinaturaUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteAssinaturaMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAssinatura>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAssinatura>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteAssinatura'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAssinatura>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteAssinatura(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAssinaturaMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAssinatura>>>

    export type DeleteAssinaturaMutationError = ErrorType<unknown>

    /**
 * @summary Delete assinatura
 */
export const useDeleteAssinatura = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAssinatura>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAssinatura>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteAssinaturaMutationOptions(options));
    }

export const getListCuponsUrl = () => {




  return `/api/admin/cupons`
}

/**
 * @summary List cupons
 */
export const listCupons = async ( options?: RequestInit): Promise<Coupon[]> => {

  return customFetch<Coupon[]>(getListCuponsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCuponsQueryKey = () => {
    return [
    `/api/admin/cupons`
    ] as const;
    }


export const getListCuponsQueryOptions = <TData = Awaited<ReturnType<typeof listCupons>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCupons>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCuponsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCupons>>> = ({ signal }) => listCupons({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCupons>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCuponsQueryResult = NonNullable<Awaited<ReturnType<typeof listCupons>>>
export type ListCuponsQueryError = ErrorType<unknown>


/**
 * @summary List cupons
 */

export function useListCupons<TData = Awaited<ReturnType<typeof listCupons>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCupons>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCuponsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateCuponUrl = () => {




  return `/api/admin/cupons`
}

/**
 * @summary Create cupom
 */
export const createCupon = async (couponInput: CouponInput, options?: RequestInit): Promise<Coupon> => {

  return customFetch<Coupon>(getCreateCuponUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      couponInput,)
  }
);}




export const getCreateCuponMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCupon>>, TError,{data: BodyType<CouponInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCupon>>, TError,{data: BodyType<CouponInput>}, TContext> => {

const mutationKey = ['createCupon'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCupon>>, {data: BodyType<CouponInput>}> = (props) => {
          const {data} = props ?? {};

          return  createCupon(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCuponMutationResult = NonNullable<Awaited<ReturnType<typeof createCupon>>>
    export type CreateCuponMutationBody = BodyType<CouponInput>
    export type CreateCuponMutationError = ErrorType<unknown>

    /**
 * @summary Create cupom
 */
export const useCreateCupon = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCupon>>, TError,{data: BodyType<CouponInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCupon>>,
        TError,
        {data: BodyType<CouponInput>},
        TContext
      > => {
      return useMutation(getCreateCuponMutationOptions(options));
    }

export const getUpdateCuponUrl = (id: number,) => {




  return `/api/admin/cupons/${id}`
}

/**
 * @summary Update cupom
 */
export const updateCupon = async (id: number,
    couponInput: CouponInput, options?: RequestInit): Promise<Coupon> => {

  return customFetch<Coupon>(getUpdateCuponUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      couponInput,)
  }
);}




export const getUpdateCuponMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCupon>>, TError,{id: number;data: BodyType<CouponInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCupon>>, TError,{id: number;data: BodyType<CouponInput>}, TContext> => {

const mutationKey = ['updateCupon'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCupon>>, {id: number;data: BodyType<CouponInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCupon(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCuponMutationResult = NonNullable<Awaited<ReturnType<typeof updateCupon>>>
    export type UpdateCuponMutationBody = BodyType<CouponInput>
    export type UpdateCuponMutationError = ErrorType<unknown>

    /**
 * @summary Update cupom
 */
export const useUpdateCupon = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCupon>>, TError,{id: number;data: BodyType<CouponInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCupon>>,
        TError,
        {id: number;data: BodyType<CouponInput>},
        TContext
      > => {
      return useMutation(getUpdateCuponMutationOptions(options));
    }

export const getDeleteCuponUrl = (id: number,) => {




  return `/api/admin/cupons/${id}`
}

/**
 * @summary Delete cupom
 */
export const deleteCupon = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteCuponUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteCuponMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCupon>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCupon>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteCupon'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCupon>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteCupon(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCuponMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCupon>>>

    export type DeleteCuponMutationError = ErrorType<unknown>

    /**
 * @summary Delete cupom
 */
export const useDeleteCupon = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCupon>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteCupon>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteCuponMutationOptions(options));
    }

export const getGetFinanceiroDashboardUrl = () => {




  return `/api/admin/financeiro`
}

/**
 * @summary Financial dashboard
 */
export const getFinanceiroDashboard = async ( options?: RequestInit): Promise<FinanceiroDashboard> => {

  return customFetch<FinanceiroDashboard>(getGetFinanceiroDashboardUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetFinanceiroDashboardQueryKey = () => {
    return [
    `/api/admin/financeiro`
    ] as const;
    }


export const getGetFinanceiroDashboardQueryOptions = <TData = Awaited<ReturnType<typeof getFinanceiroDashboard>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFinanceiroDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFinanceiroDashboardQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFinanceiroDashboard>>> = ({ signal }) => getFinanceiroDashboard({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFinanceiroDashboard>>, TError, TData> & { queryKey: QueryKey }
}

export type GetFinanceiroDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getFinanceiroDashboard>>>
export type GetFinanceiroDashboardQueryError = ErrorType<unknown>


/**
 * @summary Financial dashboard
 */

export function useGetFinanceiroDashboard<TData = Awaited<ReturnType<typeof getFinanceiroDashboard>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFinanceiroDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetFinanceiroDashboardQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







